// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/login-banner-full.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/login-img-ipad.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap'); */

body {
  font-family: "Inter", sans-serif;
  /* background-color: #f3f6f9; */
  background: #fff;
}

a {
  color: inherit;
}

.no-spin-buttons::-webkit-outer-spin-button,
.no-spin-buttons::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spin-buttons {
  -moz-appearance: textfield;
}

.suspenece-spin {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.ant-form-item .ant-form-item-label > label {
  font-size: 0.87rem;
  color: #344054;
}

.ant-form-item .ant-form-item-explain,
.ant-form-item .ant-form-item-extra {
  font-size: 0.87rem;
}

.ant-upload-drag-container .ri-upload-cloud-2-fill {
  font-size: 24px;
  color: #9a9fb8;
}

.ant-card-contain-grid {
  border-radius: 10px;
}

.ant-card .ant-card-grid-hoverable:hover {
  position: relative;
  z-index: 0;
  box-shadow: none;
}

.font-14 {
  font-size: 14px !important;
}

.font-16 {
  font-size: 16px;
}

.font-18 {
  font-size: 18px;
}

.font-22 {
  font-size: 22px;
  font-weight: 600;
}

.fontW600 {
  font-weight: 600;
}

.text-blue {
  color: rgba(26, 55, 96, 0.88);
}

/* .ant-input {
  padding: 9px 14px;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
}
.ant-input.ant-input-sm {
  padding: 4px 8px;
}
.ant-input::placeholder,
.ant-select .ant-select-selection-placeholder {
  color: #667085;
} */
.ant-layout {
  background: transparent;
}

.ant-layout main {
  padding: 40px;
}

.ant-layout-sider {
  height: max-content;
  min-height: 100vh;
  border-right: 1px solid #eaecf0;
  padding: 30px 20px;
  position: sticky !important;
  top: 0;
}

.anychart-credits {
  display: none;
}

/* .ant-menu-inline .ant-menu-item {
  height: 40px;
  line-height: 40px;
} */
.ant-menu {
  font-size: 14px;
  padding: 16px 12px;
}

.ant-menu-light.ant-menu-root.ant-menu-inline,
.ant-menu-light.ant-menu-root.ant-menu-vertical {
  border: none;
}

.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title,
.ant-menu-vertical .ant-menu-submenu-title {
  padding-inline: 16px !important;
}

.ant-menu .ant-menu-item .ant-menu-item-icon + span,
.ant-menu .ant-menu-submenu-title .ant-menu-item-icon + span,
.ant-menu .ant-menu-item .anticon + span,
.ant-menu .ant-menu-submenu-title .anticon + span {
  margin-left: 8px;
}

.ant-menu-inline-collapsed
  > .ant-menu-item-group
  > .ant-menu-item-group-list
  > .ant-menu-item
  .ant-menu-item-icon {
  font-size: 16px;
}

.ant-layout-sider .ant-menu-item {
  margin-block: 2px !important;
  height: 30px !important;
}

.ant-layout-sider .ant-menu-item-group-title {
  padding: 6px 16px;
}

/* .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item {
  padding: 8px 12px;
} */
.ant-message-notice {
  text-align: right;
  padding-right: 25px;
  padding-top: 15px;
}

/* .ant-btn {
  display: inline-flex;
  padding: 10px 18px;
  align-items: center;
  justify-content: center;
} */
.ant-btn-primary {
  box-shadow: 0 2px 2px rgb(1 9 14 / 15%);
}

.ant-table-cell-product + .ant-table-cell-product {
  border-top: 1px solid #e8e8e8;
}

.ant-table-cell .ant-btn {
  height: auto;
  font-size: 12px;
  padding: 4px 10px;
  /* padding: 0px 8px; */
  border-radius: 6px;
}

/* .ant-table-cell a:hover {
  text-decoration: underline;
} */

.ant-btn [class^="ri-"],
.ant-btn [class*=" ri-"] {
  display: inline-block;
  margin-right: 3px;
}

.ant-btn.ant-btn-sm {
  font-size: 12px;
  height: 30px;
}

.ant-input-affix-wrapper .ant-input-prefix {
  margin-right: 12px;
  color: #667085;
}

.ant-table-wrapper:not(.table-inner) .ant-table {
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  overflow: auto;
}

.ant-table-wrapper.table-inside-card .ant-table {
  border: none;
  box-shadow: none;
  /* border-radius: 0; */
  margin-top: 1px;
  border-start-start-radius: 0;
  border-start-end-radius: 0;
}

.ant-table-wrapper.table-inside-card
  .ant-table-container
  table
  > thead
  > tr:first-child
  > *:first-child {
  border-start-start-radius: 0;
}

.ant-table-wrapper.table-inside-card
  .ant-table-container
  table
  > thead
  > tr:first-child
  > *:last-child {
  border-start-end-radius: 0;
}

.table-inside-card .ant-table-cell {
  padding: 8px 12px !important;
}

.ant-table-wrapper.table-inside-card-addons .ant-table {
  border: none;
  box-shadow: none;
  /* border-radius: 0; */
  margin-top: 1px;
  border-start-start-radius: 0;
  border-start-end-radius: 0;
}

.ant-table-wrapper.table-inside-card-addons
  .ant-table-container
  table
  > thead
  > tr:first-child
  > *:first-child {
  border-start-start-radius: 0;
}

.ant-table-wrapper.table-inside-card-addons
  .ant-table-container
  table
  > thead
  > tr:first-child
  > *:last-child {
  border-start-end-radius: 0;
}

.table-inside-card-addons .ant-table-cell {
  padding: 8px 12px !important;
}

.table-inside-card-addons .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-top: 0px !important;
}

.table-inside-card-addons .indent-level-1 + .ant-table-row-expand-icon {
  visibility: hidden;
}

.page-listing .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-top: 0px !important;
}

.page-listing .indent-level-1 + .ant-table-row-expand-icon {
  visibility: hidden;
}

.expand-warehouse-table .ant-table {
  border: none !important;
  box-shadow: none !important;
}

.profile-details-card {
  border: 1px solid #e8e8e8 !important;
}

.profile-details-card .ant-card-body {
  /* padding: 2rem 2.25rem; */
  border-radius: 12px;
}

.profile-details-card .ant-card-body .title {
  color: #030229;
  font-weight: 500;
  /* font-size: 16px; */
}

.status-tag {
  padding: 4px 10px;
  font-size: 0.8rem;
  font-weight: normal;
}

.profile-details-card .details {
  color: #030229;
  font-weight: 400;
  /* font-size: 16px; */
}

.title {
  color: rgba(26, 55, 96, 0.88);
  font-weight: 600;
  /* font-size: 16px; */
}

.details {
  color: #99a1b7;
  font-weight: 500;
  font-size: 14px;
}

.text-030229 {
  color: #030229;
}

.text-03022903 {
  color: #0302294d;
}

.card-title-custom .ant-card-head-title {
  /* color: #030229; */
  font-size: 14px;
  font-weight: 600;
}

.card-title-custom .ant-card-body {
  border-radius: 12px;
}

.card-title-custom .ant-card {
  border: 1px solid #e8e8e8;
}

.card-title-custom {
  /* padding: 13px; */
  border-radius: 12px;
  border: 1px solid #e8e8e8 !important;
}

.ant-tabs-tab-btn {
  /* font-size: 16px; */
  color: rgba(26, 55, 96, 0.88);
}

.tabs-custom .status-icon-box {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs-custom .vendor-po-title {
  color: #4f4e6a;
  font-weight: 700;
  font-size: 16px;
  line-height: 2rem;
  margin-bottom: 0;
}

.tabs-custom .vendor-po-desc {
  color: #4f4e6a;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5rem;
}

.background-5B93FF {
  background-color: #eff4ff;
}

.background-FFF7E1 {
  background-color: #ffd56b3f;
}

.background-FFFBF9 {
  background-color: #ff906b3a;
}

.border-bottom {
  border-bottom: 0.5px solid #03022919;
}

/* customer details css end */
.ant-row {
  min-width: 100%;
}

.ant-steps-vertical .ant-steps-item {
  padding-bottom: 50px;
}

.mt40 {
  margin-top: 40px !important;
}

.mt6 {
  margin-top: 6px;
}

.mt8 {
  margin-top: 8px;
}

.mt10 {
  margin-top: 10px;
}

.mt16 {
  margin-top: 16px;
}

.mt20 {
  margin-top: 20px;
}

.mt24 {
  margin-top: 24px;
}

.mt30 {
  margin-top: 30px;
}

.mt-2 {
  margin-top: 2px;
}

.mb-9 {
  margin-bottom: 9px;
}

.mb0 {
  margin-bottom: 0 !important;
}

.mb28 {
  margin-bottom: 28px;
}

.mb24 {
  margin-bottom: 24px;
}

.mb16 {
  margin-bottom: 16px;
}

.mb8 {
  margin-bottom: 8px;
}

.mb2 {
  margin-bottom: 2px;
}

.me4 {
  margin-right: 12px;
}

.me1 {
  margin-right: 4px;
}

.my10 {
  margin: 10px 0;
}

.mx16 {
  margin: 0 16px;
}

.mx26 {
  margin: 0 26px;
}

.pt10 {
  padding-top: 10px;
}

.pb16 {
  padding-bottom: 16px;
}

.pb24 {
  padding-bottom: 24px;
}

.p-4 {
  padding: 4px;
}

.borderBottomDotted {
  border-bottom: 1px dotted;
}

.linkHover:hover {
  text-decoration: underline;
}

.borderBottom-ebebeb {
  border-bottom: 1px solid #ebebeb;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.text-center {
  text-align: center;
}

.fontWeight600 {
  font-weight: 600;
}

.text-right {
  text-align: right;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-between {
  justify-content: space-between;
}

.d-none {
  display: none;
}

.d-block {
  display: block;
}

.underline {
  text-decoration: underline;
}

.height-100 {
  height: 100%;
}

.grid {
  display: grid;
}

.grid-cols-4 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.gap30 {
  gap: 30px;
}

.mandatory-sign-mark::after {
  display: inline-block;
  margin-inline-end: 4px;
  color: #ff4d4f;
  font-size: 13px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
  margin-left: 4px;
}

.login-container {
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  /* background-color: #f3f6f9; */
  align-items: center;
  /* background-color: #a099ff;
  background-image: radial-gradient(at 48% 74%,
      hsla(253, 90%, 67%, 1) 0px,
      transparent 50%),
    radial-gradient(at 85% 24%, hsla(269, 76%, 75%, 1) 0px, transparent 50%),
    radial-gradient(at 55% 58%, hsla(39, 62%, 65%, 1) 0px, transparent 50%),
    radial-gradient(at 85% 4%, hsla(262, 88%, 74%, 1) 0px, transparent 50%),
    radial-gradient(at 10% 1%, hsla(184, 84%, 60%, 1) 0px, transparent 50%),
    radial-gradient(at 39% 5%, hsla(13, 83%, 78%, 1) 0px, transparent 50%),
    radial-gradient(at 51% 9%, hsla(288, 71%, 77%, 1) 0px, transparent 50%); */
}

.login-banner-wrapper-full {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  height: calc(100vh - 50px);
  width: 100%;
  background-size: cover;
  background-position: left;
  border-radius: 8px;
}

.login-card-new-full {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  margin: 60px auto;
  max-width: 400px;
  row-gap: 30px;
}

.login-card-new-full .logo {
  width: 200px;
}
.login-card-new-full .welcome-title-full {
  font-size: 24px;
  color: #000000;
}

.login-wrapper-full {
  padding: 24px;
}

.login-card {
  width: 100%;
  margin-top: 50px;
  border: 1px solid #e3e6e9;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
}

.login-card-new {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 0 auto;
  max-width: 400px;
  min-width: 380px;
  row-gap: 30px;
}

.login-card .logo {
  width: 120px;
}

.login-card-new .logo {
  width: 130px;
}

.login-banner {
  border-radius: 24px;
  height: calc(100vh - 40px);
  object-fit: cover;
  width: 100%;
}

.login-logo {
  width: 200px;
}

.sidebar-custom-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.header-user-card-container {
  border-radius: 6px;

  padding: 5px 10px;
}
.login-card-new > .login-form-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

@media all and (min-width: 1200px) {
  .header-user-card-container {
    min-width: 180px;
    background-color: #f4f4f4;
  }
}
@media all and (device-width: 1024px) and (orientation: landscape) {
  .login-wrapper {
    padding: 40px;
  }
  .login-banner-wrapper {
    display: none;
  }
  .login-card-wrapper {
    border-radius: 30px;
    background-color: #f2f5fd;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center center;
    height: calc(100vh - 40px);
    width: calc(100vw - 40px);
    display: flex;
    align-items: top;
    padding-top: 80px;
    justify-content: center;
    z-index: 999;
  }

  .login-card-new > .login-form-wrapper .logo {
    width: 200px;
  }
  .login-card-new > .login-form-wrapper {
    align-items: center;
  }
  .login-card-new > .login-form-wrapper .welcome-title {
    font-size: 38px;
  }
  .login-card-new {
    max-width: 300px;
    width: 100%;
  }
  .login-card-new .ant-btn-lg {
    font-size: 18px;
  }
  .login-wrapper.login-wrapper-old
    .login-card-new
    > .login-form-wrapper
    .welcome-title {
    font-size: 22px;
  }
  .login-wrapper.login-wrapper-old .login-card-new {
    max-width: 450px;
  }
  .login-wrapper.login-wrapper-old .login-card-new form {
    width: 100%;
    background: #ffff;
    padding: 40px;
    box-shadow: 0px 4px 98.2px 32px #00000012;
    border-radius: 17px;
  }
}
@media all and (device-width: 768px) and (orientation: portrait) {
  .login-wrapper {
    padding: 40px;
  }
  .login-banner-wrapper {
    display: none;
  }
  .login-card-wrapper {
    border-radius: 30px;
    background-color: #f2f5fd;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: bottom center;
    height: calc(100vh - 40px);
    width: calc(100vw - 40px);
    display: flex;
    align-items: top;
    padding-top: 80px;
    justify-content: center;
    z-index: 999;
  }
  .login-card-new {
    max-width: 500px;
    width: 100%;
  }
  .login-card-new > .login-form-wrapper .logo {
    width: 200px;
  }
  .login-card-new > .login-form-wrapper {
    align-items: center;
  }
  .login-card-new > .login-form-wrapper .welcome-title {
    font-size: 38px;
  }
  .login-card-new .ant-btn-lg {
    font-size: 18px;
  }
  .login-wrapper.login-wrapper-old
    .login-card-new
    > .login-form-wrapper
    .welcome-title {
    font-size: 22px;
  }
  .login-wrapper.login-wrapper-old .login-card-new {
    max-width: 450px;
  }
  .login-wrapper.login-wrapper-old .login-card-new form {
    width: 100%;
    background: #ffff;
    padding: 40px;
    box-shadow: 0px 4px 98.2px 32px #00000012;
    border-radius: 17px;
  }
}

.header-user-card {
  /* border: 1px solid #d0d5dd;  */
  border-radius: 8px;
  /* padding: 10px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.user-details {
  max-width: 110px;
}

.user-details-wrap {
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
  align-items: center;
}

.user-details-name {
  font-size: 12px;
  /* color: #1a3760; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
}

.user-details-email {
  font-size: 10px;
  /* color: #1a3760; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.page-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  /* padding-left: 16px;
  padding-right: 16px; */
  /* padding-left: 8px;
  padding-right: 10px; */
  padding-left: 7px;
  padding-right: 17px;
}

.page-header-wrapper .page-header-title {
  font-size: 24px;
  font-weight: bold;
}

.page-header-wrapper .page-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}
@media all and (device-width: 1024px) and (orientation: landscape) {
  .page-header-wrapper {
    flex-direction: column;
    align-items: baseline;
    gap: 20px;
    padding: 0 20px;
    margin-bottom: 10px;
  }
  .page-header-wrapper .page-header-title > div {
    margin-left: 0 !important;
  }
  .page-header-wrapper .page-header-action,
  .page-header-wrapper .page-header-actions {
    width: 100%;
  }
  .page-header-wrapper .page-header-action > div {
    justify-content: space-between;
  }
}
@media all and (device-width: 768px) and (orientation: portrait) {
  .page-header-wrapper {
    flex-direction: column;
    align-items: baseline;
    gap: 20px;
    padding: 0 20px;
    margin-bottom: 10px;
  }
  .page-header-wrapper .page-header-title > div {
    margin-left: 0 !important;
  }
  .page-header-wrapper .page-header-action,
  .page-header-wrapper .page-header-actions {
    width: 100%;
  }
  .page-header-wrapper .page-header-action > div {
    justify-content: space-between;
  }
}
.search-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 350px;
}

.card-checkbox .ant-checkbox-wrapper {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  padding: 15px 28px 15px 10px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
}

.card-checkbox .ant-checkbox-wrapper .ant-checkbox {
  position: absolute;
  top: 5px;
  right: 5px;
}

.card-checkbox .ant-checkbox-wrapper .ant-checkbox .ant-checkbox-inner,
.card-checkbox .ant-checkbox-checked:after {
  border-radius: 100%;
}

.card-checkbox
  .ant-checkbox-wrapper
  .ant-checkbox:not(.ant-checkbox-checked)
  .ant-checkbox-inner {
  border-color: transparent;
}

.card-checkbox .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {
  background-color: #e6f4ff;
  border-color: #1677ff;
  border-width: 2px;
  padding: 14px 27px 14px 9px;
  /* border-width: 2px; */
}

.report_type_checkboxes .ant-checkbox-wrapper {
  padding: 15px 28px 15px 28px;
}

.report_type_checkboxes .ant-checkbox + span {
  width: 100%;
  text-align: center;
}

.report_type_checkboxes .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {
  padding: 14px 27px 14px 27px;
}

.marketplace-region {
  color: #8996a9;
}

.antd-table-filter-dropdown {
  padding: 15px 10px;
  min-width: 200px;
  display: flex;
  justify-content: center;
}

.appplied-filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.applied-filter-tag {
  font-size: 10px;
  font-weight: 400;
}

.applied-filter-value {
  font-size: 10px;
  font-weight: 700;
}

.applied-filters-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  flex-grow: 1;
}

.applied-filter-wrap {
  padding: 8px;
  background-color: #ffffff;
  color: #132237;
  border-radius: 8px;
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  height: auto;
  border: 1px solid #e3e6e9;
}

.applied-filter-wrap > span {
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.applied-filter {
  font-weight: bold;
}

.applied-filter > span {
  font-size: 10px;
  font-weight: normal;
  margin-right: 10px;
}

.applied-filter-wrap .applied-filter-remove {
  display: flex;
  align-items: flex-start;
  margin-left: 5px;
  cursor: pointer;
}

.detail-block {
  line-break: anywhere;
}

.detail-block > label,
.detail-block > span {
  display: block;
}

.detail-block > label {
  font-size: 14px;
  color: #667085;
  margin-bottom: 3px;
}

.detail-block > span {
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
}

.marketplace-detail-card,
.report-type-wrapper {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  padding: 15px 28px 15px 10px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  position: relative;
  font-weight: normal;
  text-align: center;
}

.report-type-wrapper {
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 18px 20px;
  width: 100%;
  white-space: nowrap;
}

.table-tag .ant-alert {
  display: inline-flex;
  padding: 4px 8px;
}

.table-tag .ant-alert .ant-alert-content {
  font-size: 12px;
}

.product-image-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.product-image-wrapper {
  width: 102px;
  height: 102px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
}

.product-image-wrapper-sm {
  width: 50px;
  height: 50px;
  padding: 5px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
}

.product-title {
  font-size: 16px;
}

.product-price {
  color: #1677ff;
}

.product-compatibility-image {
  /* border: 1px solid rgba(235, 235, 235, 1); */
  min-height: 80px;
  min-width: 80px;
  /* object-fit: cover; */
  object-fit: contain;
  /* border-radius: 6px; */
  aspect-ratio: 1 / 1;
}

.detail-block > label {
  /* font-weight: 600; */
}

.detail-block ul {
  padding-inline-start: 16px;
  list-style-type: decimal;
}

.detail-block ul li {
  font-size: 18px;
  font-weight: bold;
}

.pd-identifier {
  color: #667085;
  margin-bottom: 10px;
  display: block;
}

.pd-product-name {
  font-weight: bold;
  font-size: 20px;
}

.ant-descriptions-item-content ul {
  padding-left: 18px;
}

.pd-status-wrap {
  display: inline-block;
  margin-bottom: 20px;
}

.amazon-serach-modal-search
  .ant-input-group
  .ant-input-group-addon
  .ant-select {
  margin: 0;
  border: 1px solid #d9d9d9;
  border-radius: 8px 0 0 8px;
  border-right: 0px;
}

.amazon-serach-modal-search .ant-input-group .ant-input-group-addon {
  padding: 0;
  border: 0;
}

.amazon-serach-modal-search .ant-input-group .ant-input {
  height: 46px;
}

.amazon-serach-modal-search .ant-input-group .ant-input-group-addon .ant-btn {
  border-radius: 0 8px 8px 0;
  border-left: 0;
  height: 46px;
}

.read-more-btn {
  background-color: transparent;
  border: none;
  color: #8996a9;
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.w-100 {
  width: 100%;
}

@media all and (min-width: 576px) {
  .login-card {
    width: 480px;
    padding: 40px;
    padding-bottom: 50px;
  }
}

.ant-checkbox-wrapper {
  align-items: center;
}

.ant-form-item-required::before {
  order: 1;
  margin-right: 0;
  margin-left: 4px;
}

.ant-list-bordered {
  overflow: hidden;
}

.prdouct-info-btn {
  display: flex;
  justify-content: flex-end;
}

.password-field label {
  width: 100%;
}

.password-field .password-field-label {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ant-form-item .ant-form-item-label > label::after {
  display: none;
}

.password-field .ant-form-item-extra {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateY(-100%);
}

.ant-layout .ant-layout-sider-light {
  background-color: #ffffff;
  padding: 0;
  /* border: 0; */
}

.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper,
.ant-layout-header {
  height: 56px;
}

.ant-layout-header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  line-height: 1.25;
  padding: 0 16px;
  z-index: 1;
  border-bottom: 1px solid #eaecf0;
}

.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper {
  padding: 5px 16px;
}

.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper img {
  max-height: 100%;
  margin: 0;
}

.ant-layout-sider .ant-menu-item {
  font-weight: 500;
}

.ant-pagination .ant-pagination-item {
  border-radius: 6px;
}

.ant-card {
  box-shadow: rgba(26, 26, 26, 0.07) 0px 1px 0px 0px;
  border: 1px solid rgb(204, 204, 204, 0.5);
}

.ant-picker {
  width: 100%;
}

.ant-list-bordered {
  background-color: #fff;
}

.address-make-default-btn {
  opacity: 0;
  transition-duration: 0.3s;
}

.ant-collapse-header:hover .address-make-default-btn {
  opacity: 1;
}

.ant-upload-wrapper.ant-upload-picture-card-wrapper
  .ant-upload-list.ant-upload-list-picture-card
  .ant-upload-list-item-thumbnail
  img {
  aspect-ratio: 1/1;
}

.ant-upload-list {
  margin-top: 8px;
}

.ant-upload-wrapper.ant-upload-picture-card-wrapper
  .ant-upload-list.ant-upload-list-picture-card
  .ant-upload-list-item-container,
.ant-upload-wrapper.ant-upload-picture-card-wrapper
  .ant-upload.ant-upload-select {
  width: 80px;
  height: 80px;
}

.ant-upload-wrapper
  .ant-upload-list.ant-upload-list-picture-card
  .ant-upload-list-item {
  border-radius: 8px;
  padding: 6px;
}

.ant-upload-wrapper
  .ant-upload-list.ant-upload-list-picture-card
  .ant-upload-list-item
  .ant-upload-list-item-thumbnail {
  border-radius: 4px;
}

.ant-upload-wrapper.ant-upload-picture-card-wrapper
  .ant-upload-list.ant-upload-list-picture-card
  .ant-upload-list-item::before {
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  top: 0;
  left: 0;
  border-radius: 6px;
}

.ant-upload-wrapper
  .ant-upload-list
  .ant-upload-list-item
  .ant-upload-list-item-actions
  .ant-upload-list-item-action.ant-btn-sm {
  padding: 10px 5px;
  width: auto;
  height: auto;
  background-color: #ffffff29;
  border: 1px solid #ffffff50;
}

.ant-menu-sub.ant-menu-inline .ant-menu-item {
  padding-left: 38px !important;
}

.form-remove-btn {
  margin-top: 32px;
  font-size: 18px;
}

.ql-toolbar.ql-snow {
  border-radius: 8px 8px 0 0;
  padding: 5px 3px;
  font-family: "Inter", sans-serif;
}

.ql-toolbar.ql-snow .ql-picker-label {
  border-radius: 5px;
}

.ql-toolbar.ql-snow .ql-picker-options {
  border-radius: 8px;
}

.ql-container {
  font-family: "Inter", sans-serif;
}

.ql-container.ql-snow {
  border-radius: 0 0 8px 8px;
}

.ql-editor {
  min-height: 5rem;
  max-height: 30rem;
  overflow-y: auto;
}

.hamburger-responsive {
  /* border: 1px solid #4c535e; */
  background-color: #2b2f35;
  height: 37px;
  width: 37px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.nav-logo-responsive {
  max-height: 37px;
  width: auto;
}

.form-tab-section {
  margin: 24px 0px;
}

.form-tab-section .ant-tabs-nav {
  margin-bottom: 0px;
  /* z-index: 1; */
  /* border-bottom: 1px solid rgb(204, 204, 204, 0.5); */
}

.form-tab-section .ant-tabs-tabpane > .ant-card {
  background: transparent;
  border-top-right-radius: 0%;
  border-top-left-radius: 0%;
  /* border-top: none; */
  position: relative;
  /* z-index: -1; */
}

.form-tab-section .ant-tabs-tab-active {
  background: #f3f6f9 !important;
  border: 1px solid rgb(204, 204, 204, 0.5) !important;
  border-bottom: none !important;
}

.form-tab-section .ant-tabs-nav {
  position: sticky;
  top: 56px;
}

.form-tab-section .ant-tabs-top > .ant-tabs-nav::before {
  border-bottom-color: rgb(204, 204, 204, 0.5);
}

.form-tab-section .ant-tabs-nav-wrap {
  background: #f3f6f9;
}

.form-tab-section .ant-tabs-tab-active::after {
  position: absolute;
  right: 0;
  left: 0;
  bottom: -4px;
  /* border-bottom: 3px solid #172539; */
  border: 3px solid #f3f6f9;
  content: "";
  /* z-index: 2; */
}

.header-user-card-container {
  cursor: pointer;
}

.ant-menu-sub .ant-menu-item {
  height: 28px;
  line-height: 28px;
}

.ant-menu-submenu-open {
  background-color: rgba(0, 0, 0, 0.02);
}

.ant-menu-inline-collapsed .ant-menu-item-group-title {
  opacity: 0;
  /* height: ; */
}

.ant-menu-item-group:not(:first-child) {
  margin-top: 0px;
}

.sidebar-responsive {
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  padding: 0;
  border: 1px solid #eee;
}

.ant-menu-light.ant-menu-root.ant-menu-inline {
  overflow-y: auto;
}

.table-cell-link {
  font-weight: 700;
}

/* .table-cell-link:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
} */

.table-cell-product-image {
  border: 1px solid rgba(235, 235, 235, 1);
  min-height: 40px;
  min-width: 40px;
  /* object-fit: cover; */
  object-fit: contain;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
}

.ant-table-cell-with-append {
  /* display: flex; */
  align-items: center;
}

.ant-table-wrapper:not(.table-inner)
  .ant-table-row-indent
  + .ant-table-row-expand-icon {
  border-color: #1a3760e0;
  margin-top: 12px;
}

.ant-table-wrapper.expand-without-image
  .ant-table-row-indent
  + .ant-table-row-expand-icon {
  display: none;
}

/* .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
  background: rgb(26 55 96 / 7%);
  border: none;
} */

/* .ant-tabs > .ant-tabs-nav .ant-tabs-nav-add {
  border: none;
  background: rgb(26 55 96 / 7%);
} */

.purchase-order-table {
  margin-top: 12px;
}

.purchase-order-table.ant-table-wrapper .ant-table {
  border: none;
  box-shadow: none;
  border-radius: 0;
}

.purchase-order-table.ant-table-wrapper .ant-table-container,
.purchase-order-table.ant-table-wrapper .ant-table-container table,
.purchase-order-table.ant-table-wrapper
  .ant-table-container
  table
  > thead
  > tr:first-child
  > *:first-child,
.purchase-order-table.ant-table-wrapper
  .ant-table-container
  table
  > thead
  > tr:first-child
  > *:last-child {
  border-radius: 0;
}

.purchase-order-table .ant-table-cell {
  vertical-align: top;
}

.recieve-order-progress .ant-progress .ant-progress-success-bg {
  background-color: rgba(41, 132, 90, 1);
}

.recieve-order-progress .ant-progress-bg {
  background-color: rgba(181, 38, 11, 1);
}

.inventory-unavaible-card .ant-card-body {
  padding: 4px;
}

.inventory-unavaible-card .ant-card-head {
  padding: 4px;
  min-height: auto;
}

.order-user-card .ant-card {
  border: 0px;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.order-user-card .ant-card:hover {
  border: 0px;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.order-user-card .ant-card .ant-card-body {
  padding: 8px;
  border-radius: 0;
}

.order-user-link-card .ant-card {
  border: 0px;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.order-user-link-card .ant-card:hover {
  border: 0px;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.order-user-link-card .ant-card .ant-card-body {
  padding: 8px;
  border-radius: 0;
}

.collection-product-table .ant-table-container .ant-table-thead {
  display: none;
}

.collection-product-table {
  margin-top: 24px;
}

.comment-section .comment-section-input {
  border: none;
  padding-left: 0;
}

.comment-section
  .ant-input-status-error:not(.ant-input-disabled):not(
    .ant-input-borderless
  ).ant-input:focus,
.comment-section .ant-input:focus {
  box-shadow: none;
}

.comment-section .ant-card-small > .ant-card-body {
  padding: 0;
}

.comment-section .comment-section-top {
  padding: 12px;
}

.comment-section .comment-section-bottom {
  padding: 12px;
  background-color: #f3f6f9;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.comment-section-block {
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: 4px;
  height: 40px;
  border-inline-start: 2px solid rgba(5, 5, 5, 0.06);
}

.log-inventory_received .ant-table-wrapper:not(.table-inner) .ant-table {
  border: none;
  box-shadow: none;
  border-radius: 0px;
  overflow: auto;
}

.log-inventory_received .ant-table-wrapper .ant-table-thead > tr > th,
.log-inventory_received .ant-table-wrapper .ant-table-thead > tr > td {
  position: relative;
  color: rgba(26, 55, 96, 0.88);
  font-weight: 600;
  text-align: start;
  background: transparent;
  border-bottom: none;
}

.log-inventory_received .ant-table-wrapper .ant-table {
  background: transparent;
}

.log-inventory_received .ant-table-wrapper .ant-table-tbody > tr > td {
  border-bottom: none;
}

.log-inventory_received
  .ant-table-wrapper
  .ant-table-thead
  > tr
  > th:not(:last-child):not(.ant-table-selection-column):not(
    .ant-table-row-expand-icon-cell
  ):not([colspan])::before {
  background-color: transparent;
}

.log-inventory_received .log-inventory_received-description:hover {
  text-decoration: underline;
  cursor: pointer;
}

.log-inventory_received .log-inventory_received-arrow:hover {
  cursor: pointer;
}

.log-inventory_received .log-inventory_received-description-container {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mt3 {
  margin-top: 3px;
}

/* product page start */
.product-add-page .ant-select-selector .ant-select-selection-search-input {
  height: 50px !important;
}
.product-add-page
  .ant-select-multiple.ant-select-lg
  .ant-select-selection-item {
  height: 40px !important;
}
.product-variation-table {
  margin-top: 24px;
}
.product-variation-table.ant-table-wrapper
  .ant-table-tbody
  > tr
  > td.ant-table-cell {
  padding: 2px 8px;
}
.product-variation-table.ant-table-wrapper
  .ant-table-tbody
  > tr
  > td.ant-table-cell
  .ant-form-item {
  margin: 0;
}
.product-variation-table
  .ant-upload-wrapper.ant-upload-picture-card-wrapper
  .ant-upload-list.ant-upload-list-picture-card
  .ant-upload-list-item-container,
.product-variation-table
  .ant-upload-wrapper.ant-upload-picture-card-wrapper
  .ant-upload.ant-upload-select {
  width: 60px;
  height: 60px;
}

.product-variation-table .ant-upload-select strong {
  font-weight: 400;
}
.product-variation-table .ant-table {
  overflow: unset !important;
  overflow-y: hidden !important;
  overflow-x: auto !important;
}
/* product page end */

/* cms page form css start */
.dashed-border {
  /* border:1px dashed #8996a9; */
  margin-top: 20px;

  border-top: 1px dashed #8996a9;
}

.form-title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}

.form-description {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}

.form-box {
  background-color: white;
  padding: 32px;
}

/* cms page form css end */

/* sticky footer css start */
.sticky-footer {
  position: sticky;
  bottom: 0;
  -webkit-backdrop-filter: blur(9px);
          backdrop-filter: blur(9px);
  background-color: rgba(243, 244, 246, 0.1);
  text-align: right;
  padding-left: 2rem;
  padding-right: 2rem;
  margin-left: -2rem;
  margin-right: -2rem;
  z-index: 999;
}

.sticky-footer-padding {
  position: sticky;
  bottom: 0;
  -webkit-backdrop-filter: blur(9px);
          backdrop-filter: blur(9px);
  background-color: rgba(243, 244, 246, 0.1);
  text-align: right;
  padding: 1.5rem 3.2rem;
  /* padding-left: 2rem;
  padding-right: 2rem; */
  margin-left: -2rem;
  margin-right: -2rem;
}

.ant-card .ant-card-actions > li {
  margin: 4px 0;
}

.ant-card .ant-card-head-title {
  overflow: visible;
}

.google-places-autocomplete {
  margin-bottom: 24px;
}

.google-places-autocomplete div[class\$="control"]::before {
  width: 24px;
  height: 24px;
  content: "";
  background-image: url("https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg");
  background-size: 24px 24px;
  position: absolute;
  top: 4px;
  left: 4px;
  pointer-events: none;
}

.google-places-autocomplete div[class\$="control"] {
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-radius: 8px;
  transition: all 0.2s;
  min-height: 32px;
  height: auto;
  padding-left: 32px;
}

.google-places-autocomplete div[class\$="indicatorContainer"] {
  padding: 6px;
}

.google-places-autocomplete div[class\$="Input"] {
  margin: 0;
}

/* sticky footer css end */

/* filter section start */
.filter-section {
  margin: 16px 0px;
}

.filter-section .ant-card .ant-card-body {
  padding: 4px;
}

.filter-section .ant-btn.ant-btn-sm {
  padding: 5.5px 8px;
}

.filter-section .ant-btn.ant-btn-sm.ant-btn-text {
  padding: 5.5px 12px;
  font-weight: 600;
}

.filter-section-head {
  border-bottom: 1px solid rgb(204, 204, 204, 0.5);
  padding: 10px 10px 10px 10px;
}

/* filter section end */

/* Vendor View start */
.vendor-tabs .ant-tabs-nav {
  margin: 0;
}

.vendor-tabs .ant-tabs-tab {
  padding: 0px 0px 12px 0px;
}

.status-icon-box {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.vendor-po-title {
  color: #4f4e6a;
  font-weight: 700;
  font-size: 16px;
  line-height: 2rem;
}

.vendor-po-desc {
  color: #4f4e6a;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5rem;
}

.background-fff7e6 {
  background-color: #fff7e6;
}

.background-eff5ff {
  background-color: #eff5ff;
}

.background-ffe9e1 {
  background-color: #ffe9e1;
}

.vendor-table .ant-table-wrapper .ant-table-thead > tr > th {
  border-top: 1px solid #f0f0f0;
  /* background: #E8E8E8; */
}

.vendor-table
  .ant-table-wrapper
  .ant-table-thead
  > tr
  > th:not(:last-child):not(.ant-table-selection-column):not(
    .ant-table-row-expand-icon-cell
  ):not([colspan])::before {
  height: 0;
  width: 0;
}

/* Vendor View end */

/* Settings Start */
.header-setting .menu-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-setting .menu-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 2rem;
  margin-bottom: 0;
}

.background-ff6b6b3a {
  background-color: #ff8b8b3a;
  color: rgb(235 29 29);
}

.background-6bff6b3a {
  background-color: #80ff803a;
  color: #15b41e;
}

.background-5572a3 {
  background-color: #5572a324;
  color: #5572a3;
}

.background-648cff {
  background-color: #e0e6ef;
  color: #648cff;
}

/* Settings end */

/* Order Refund Start */
.order-refunds-table
  > .ant-collapse-item
  > .ant-collapse-content
  > .ant-collapse-content-box {
  padding: 0;
}
/* Order Refund End */

/* Add Order Screen Start */
.add-order-spin {
  height: 40vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.add-order-container {
  margin-top: 20px;
}

.total-container {
  padding: 20px 20px 0px 20px;
}

.total-container .main-title {
  font-size: 14px;
  font-weight: 600;
}

.add-order-container .ant-card-body {
  height: 100%;
}

.no-address-available {
  /* border: 1px dashed gray; */
  height: 20vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.add-order-container .product-image {
  border: 1px solid rgba(235, 235, 235, 1);
  min-height: 80px;
  min-width: 80px;
  /* object-fit: cover; */
  object-fit: contain;
  border-radius: 6px;
  aspect-ratio: 1 / 1;
  z-index: 0;
  width: 100%;
}
.add-order-container .ant-image {
  width: 100%;
}

.add-order-container .product-price {
  color: #ffffff;
  background-color: #b12525;
  width: fit-content;
  padding: 0px 8px;
  border-radius: 4px;
  position: absolute;

  z-index: 1;
}

.add-order-container .product-quantity {
  color: #027a48;
  background-color: #ecfdf3;
  width: fit-content;
  padding: 0px 8px;
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  right: 12px;
}

.checkout-address .ant-radio-checked + span > .ant-card {
  border-color: #b12525;
}

.checkout-address .ant-radio {
  display: none;
}

.checkout-address .ant-radio + span {
  padding-inline-start: 0px;
  padding-inline-end: 0px;
  height: 100%;
  width: 100%;
}
.checkout-address .ant-radio-wrapper {
  margin-inline-end: 0px;
  height: 100%;
  width: 100%;
}
.checkout-address .ant-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
}

.cart-drawer-btn {
  background-color: #b12525;
  display: flex;
  flex-direction: column;
  border: none;
  box-shadow: none;
  padding: 14px 12px 12px 12px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  position: fixed;
  right: 0;
  top: 45%;
  z-index: 999;
}

.cart-drawer-btn .cart-total-item {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
}

.cart-drawer-btn .cart-price {
  background-color: #ffffff;
  padding: 8px;
  margin-top: 12px;
  border-radius: 5px;
  color: #b12525;
  font-size: 14px;
  font-weight: 600;
  width: 100%;
}

.cart-total-item {
  color: #b12525;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
}

.cart-drawer .ant-drawer-body {
  position: relative;
  /* overflow: initial; */
}

.cart-drawer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  overflow-y: auto;
}

.cart-drawer-total {
  position: sticky;
  bottom: 0;
  background-color: #ffffff;
  width: 100%;
}

.cart-drawer-product-image {
  border: 1px solid rgba(235, 235, 235, 1);
  min-height: 50px;
  min-width: 50px;
  object-fit: contain;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
}

.shipping-service .ant-radio-checked + span > .ant-card {
  border-color: #b12525;
}

.shipping-service .ant-radio {
  display: none;
}

.shipping-service .ant-radio + span {
  display: block;
  width: 100%;
  padding-inline-start: 0px;
  padding-inline-end: 0px;
}

.default-btn-style .ant-btn-default {
  background: #ffffff;
  border-color: #b12525;
  color: rgba(17, 17, 17, 0.88);
  box-shadow: 0 2px 0 rgba(17, 17, 17, 0.02);
}

/* .default-btn-style .ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover{
  color: #bd4a46;
    border-color: #d9d9d9;
    background: #ffffff;
} */

.add-to-cart-title {
  margin-bottom: 24px;
  color: #b12525;
  font-size: 1.5rem;
  line-height: 2rem;
  text-align: center;
}

.text-modal-b12525 {
  color: #b12525;
}

.add-to-cart-mt-4 {
  margin-top: 24px;
}
.add-to-cart-mb-2 {
  margin-bottom: 8px;
}

.core-refund-text {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 8px;
}

.core-refund-text-radio {
  font-size: 14px;
}

.order-management-product-image {
  border: 1px solid rgba(235, 235, 235, 1);
  min-height: 50px;
  min-width: 50px;
  object-fit: contain;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
}

.order-product-collapse .ant-collapse-content-box {
  padding: 6px 0px !important;
}
.order-product-collapse .ant-collapse-header {
  padding: 4px 0px !important;
  padding-inline-start: 0px;
}

/* Add Order Screen End */

/* Shipping Zone start */
.no-form-input-label .ant-form-item-label label {
  color: transparent;
}
.no-form-input-label .ant-form-item-label .ant-form-item-required::before {
  color: transparent !important;
}
/* Shipping Zone end */

/* CMS start */
.ant-picker {
  width: 100%;
}

.ant-upload-list {
  margin-bottom: 8px;
}

.ant-upload-picture-card-wrapper .ant-upload-drag {
  margin-bottom: 16px;
}

.ant-upload-list-item-thumbnail,
.ant-upload-list .ant-upload-list-item-container .ant-upload-list-item::before {
  border-radius: 10px;
}

.ant-tag {
  padding: 4px 10px;
  font-size: 10px;
}

.table-cell-product-image {
  border-radius: 7px;
}

.ant-form-item .ant-form-item-label > label::before {
  order: 1;
  margin-left: 4px;
  margin-right: 4px;
}

.ant-form-item .ant-form-item-label > label::after {
  order: 2;
}

.media-wrapper {
  aspect-ratio: 1;
  border: 1px solid #ccc;
  border-radius: 16px;
}

.media-wrapper .ant-image {
  width: 100%;
  border-radius: 16px;
  height: 100%;
  cursor: pointer;
}

.ant-modal-body .media-wrapper-selected {
  position: relative;
}

.ant-modal-body .media-wrapper-selected::after {
  content: "✓";
  font-size: 20px;
  position: absolute;
  color: #fff;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.ant-modal-body .media-wrapper-selected::before {
  content: "";
  height: 40px;
  width: 40px;
  background-color: #9d0d93;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  border-radius: 20px;
}

.media-wrapper-selected {
  outline: 2px solid #9d0d93;
  border: 1px solid #fff;
  position: relative;
}

.media-wrapper-selected .ant-image {
  opacity: 0.3;
}

.media-wrapper-selected::before {
  content: "";
  width: 100%;
  height: 100%;
}

/* .ant-image .ant-image-mask {
  display: none;
}*/
.media-preview {
  border: 1px solid #ccc;
  max-width: 150px;
  aspect-ratio: 1;
  border-radius: 16px;
}

.media-preview {
  object-fit: contain;
}

.media-preview ~ .ant-image-mask {
  border-radius: 16px;
}

.media-wrapper .ant-image .ant-image-mask:hover {
  opacity: 0;
}

.media-wrapper .ant-image .ant-image-img,
.media-wrapper .ant-image .ant-image-mask {
  border-radius: 16px;
}

.media-wrapper .ant-image .ant-image-img {
  height: 100%;
  object-fit: contain;
}

.toolbar-wrapper {
  /* position: fixed;
  bottom: 32px;
  left: 50%;
  padding: 0px 24px;
  color: #fff;
  font-size: 20px; */
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  /* transform: translateX(-50%);  */
}

.toolbar-wrapper .anticon {
  padding: 12px;
  cursor: pointer;
}

.toolbar-wrapper .anticon[disabled] {
  cursor: not-allowed;
  opacity: 0.3;
}

.toolbar-wrapper .anticon:hover {
  opacity: 0.3;
}

.media-wrapper .ant-skeleton-element,
.media-wrapper .ant-skeleton-element .ant-skeleton-image {
  width: 100%;
  height: 100%;
  border-radius: 16px;
}

.ql-disabled {
  color: rgba(17, 17, 17, 0.25);
  background-color: rgba(17, 17, 17, 0.04);
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

/* Update Profile Css */

.popOverIcon {
  position: absolute;
  top: -17px !important;
  left: -50px !important;
}

.popOverIcon .ant-popover {
  left: 80px !important;
  top: -5px !important;
}

.popOverIcon .ant-popover .ant-popover-content .ant-popover-inner {
  padding: 4px 8px !important;
}

.popOverIcon
  .ant-popover
  .ant-popover-content
  .ant-popover-inner
  .ant-popover-inner-content
  .uploadDeleteBtn {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
}

.popOverIcon .editIcon {
  width: 26px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid transparent;
  position: absolute;
  left: 40px;
  top: 8px !important;
  background: #ffffff;
  box-shadow: 0px 0px 3.35509px rgba(0, 0, 0, 0.25);
  padding: 4px;
}

.uploadBtn,
.deleteBtn {
  border: none;
}

/* .btnCmsPageCard{
  all: unset;
}

.btnCmsPageCard:disabled,
 btnCmsPageCard[disabled]{
  color: rgba(17, 17, 17, 0.25);
  border-color: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
} */

/* CMS end */

/* Dashboard start */
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.dashboard-header .page-title-wrapper .page-header-title {
  font-size: 20px;
  font-weight: 600;
  color: #111111e0;
  margin-bottom: 6px;
}
.dashboard-header .page-title-wrapper .page-header-description {
  font-size: 12px;
  font-weight: 400;
  color: #00000073;
}
.dashboard-components .ant-card,
.dashboard-components .ant-card-body {
  width: 100%;
}
.dashboard-components .mb10 {
  margin-bottom: 10px;
}
.dashboard-components .analytics-icon-box {
  padding: 18px;
  padding-bottom: 14px;
  border-radius: 8px;
  width: fit-content;
}
.dashboard-components .color-orders {
  background-color: #e6f4ff;
  color: #4f90d4;
}
.dashboard-components .color-net-sales {
  background-color: #cefcd67a;
  color: #48aa5a;
}
.dashboard-components .color-average-order-value {
  background-color: #fff7e6;
  color: #d46b08;
}
.dashboard-components .color-average-item-per-order {
  background-color: #dbc4ff61;
  color: #6232b1;
}
.dashboard-components .color-registered-customers {
  background-color: #ffbcbc3d;
  color: #b12525;
}
.dashboard-components .color-conversion-rate {
  background-color: #b7ffff63;
  color: #008080;
}
.dashboard-components .analytics-title {
  font-size: 14px;
  color: #11111173;
  font-weight: 400;
}
.dashboard-components .analytics-value {
  font-size: 22px;
  color: #111111e0;
  font-weight: 500;
}
.dashboard-components .main-card-title {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #111111e0;
  margin-bottom: 0px;
}
.dashboard-components .live-user-count {
  font-size: 48px;
  font-weight: 600;
  color: #111111e0;
  margin-bottom: 4px;
  margin-top: 12px;
  text-align: center;
  line-height: normal;
}
.dashboard-components .live-user-count-description {
  color: #00000073;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
}
.dashboard-components .order-fulfilment-chart-container .apexcharts-canvas {
  margin: 0 auto;
}

.dashboard-filter {
  display: flex;
  align-items: center;
  gap: 16px;
}
.dashboard-filter .ant-select {
  min-width: 120px;
  /* max-width: 100%; */
  width: 100%;
  max-width: 130px;
}

.custom-info-alert {
  margin-top: 10px;
  padding: 14px;
  background: transparent !important;
}
.custom-info-alert.ant-alert-info {
  background-color: #e6f4ff; /* light blue background */
  border: 1px solid #91caff; /* border */
  color: #1677ff; /* text/icon */
}
.custom-info-alert.ant-alert-info .ant-alert-icon {
  color: #1677ff; /* force the icon color */
}

.announcement-card .ant-timeline-item-head-blue {
  color: #1677ff !important;
  border-color: #1677ff !important;
}
/* Dashboard end */

/* Report start */
.report-tab-container .ant-tabs-nav-wrap,
.report-tab-container .ant-tabs-nav-list,
.report-tab-container .ant-tabs-tab {
  width: 100%;
}
.report-tab-container
  .ant-tabs-card.ant-tabs-top
  > .ant-tabs-nav
  .ant-tabs-tab
  + .ant-tabs-tab {
  margin-left: 16px;
}
.report-tab-container .ant-tabs-tab {
  padding: 12px !important;
  border-radius: 8px 8px 0 0 !important;
  background: rgb(50 50 50 / 2%) !important;
}
.report-tab-container .ant-tabs-tab-active {
  border-bottom-color: #f0f0f0 !important;
  background: #fff !important;
}
.report-tab-container .ant-tabs-nav {
  margin: 0px;
}
.report-tab-container .ant-tabs-content-holder {
  border: 1px solid #f0f0f0;
  border-top: 0px;
  border-radius: 0px 0px 8px 8px;
}
.report-tab-container .graph-title {
  font-size: 14px;
}
/* Report end */

/* POS start */

/* POS Wrapper */
.pos-order-wrapper {
  background: #fff;
  height: 100vh; 
  display: flex;
  flex-direction: column;
  overflow: hidden;
}


/* Header */
.pos-header {
  flex-shrink: 0; /* prevent shrinking */
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 12px 16px; */
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}

.pos-logo {
  height: 40px;
  object-fit: contain;
  margin: 8px 16px;
  margin-right: 0px;
}

/* POS User Welcome */
.pos-user-welcome {
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.pos-user-welcome:hover {
  background: rgba(17, 17, 17, 0.05);
}

.pos-user-details {
  display: flex;
  flex-direction: column;
}

.pos-welcome-text {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.pos-user-name {
  color: var(--ant-primary-color, #111111);
  font-weight: 600;
}

.pos-dropdown-arrow {
  color: #999;
  transition: transform 0.3s ease;
}
.pos-cart-header {
  flex-shrink: 0; /* prevent shrinking */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}
.pos-cart-header .page-header-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--ant-primary-color, #111111);
  letter-spacing: 0.3px;
}

/* Actions on the right */
.pos-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 16px;
}

.pos-header-actions .ant-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 4px;
  height: 44px;
}

.pos-header-action-text {
  font-size: 9px;
  font-weight: 400;
}

/* POS main layout */
.pos-main {
  flex: 1 1; /* take remaining height */
  display: flex;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-top: none;
  overflow: hidden; /* prevent double scrollbars */
  height: calc(100vh - 60px); /* subtract header height */
}
/* Products area */
.pos-products {
  border-right: 1px solid #f0f0f0;
  background: #ffffff;
  overflow-y: auto;
  width: 100%;
  height: 100%; /* ensure full height */
  display: flex;
  flex-direction: column;
}

.product-listing {
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* margin: 16px 0px; */
  padding: 16px;
  flex: 1 1; /* take remaining space */
  overflow-y: auto; /* make this scrollable */
  /* Custom scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;
}

.product-listing::-webkit-scrollbar {
  width: 6px;
}

.product-listing::-webkit-scrollbar-track {
  background: transparent;
}

.product-listing::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
  border-radius: 3px;
}

.product-listing::-webkit-scrollbar-thumb:hover {
  background-color: #bfbfbf;
}

/* .product-filters {
  margin-bottom: 16px;
} */

/* Floating Filter Buttons */
.floating-filters {
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
  padding: 8px 0;
}

.filter-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 110px;
  border-radius: 0 8px 8px 0;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  color: white;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  padding: 8px 4px;
  gap: 8px;
}

/* Categories Button - Light Blue */
.filter-btn:nth-child(1) {
  background: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}

.filter-btn:nth-child(1):hover {
  background: #91d5ff;
  color: #1890ff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(24, 144, 255, 0.3);
}

.filter-btn:nth-child(1).active {
  background: #1890ff;
  color: white;
  box-shadow: 0 6px 20px rgba(24, 144, 255, 0.4);
}

/* Brands Button - Light Green */
.filter-btn:nth-child(2) {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.filter-btn:nth-child(2):hover {
  background: #b7eb8f;
  color: #52c41a;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(82, 196, 26, 0.3);
}

.filter-btn:nth-child(2).active {
  background: #52c41a;
  color: white;
  box-shadow: 0 6px 20px rgba(82, 196, 26, 0.4);
}

/* Catalogs Button - Light Orange */
.filter-btn:nth-child(3) {
  background: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
}

.filter-btn:nth-child(3):hover {
  background: #ffd591;
  color: #fa8c16;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(250, 140, 22, 0.3);
}

.filter-btn:nth-child(3).active {
  background: #fa8c16;
  color: white;
  box-shadow: 0 6px 20px rgba(250, 140, 22, 0.4);
}

.filter-btn .anticon {
  margin: 0;
  font-size: 16px;
}

.filter-text {
  font-size: 11px;
  line-height: 1.1;
  /* text-transform: uppercase; */
  letter-spacing: 1px;
  writing-mode: vertical-rl;
  /* text-orientation: upright; */
  font-weight: 600;
}

/* Active Filters */
.active-filters {
  margin-top: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

/* Filter Drawer Styling */
.filter-drawer .ant-drawer-header {
  border-bottom: none;
}

.filter-drawer .ant-drawer-title {
  color: white;
  font-weight: 600;
}

.filter-drawer .ant-drawer-close {
  color: white;
}

/* Category Drawer - Blue */
.filter-drawer:nth-of-type(1) .ant-drawer-header {
  background: #1890ff;
}

/* Brand Drawer - Green */
.filter-drawer:nth-of-type(2) .ant-drawer-header {
  background: #52c41a;
}

/* Catalog Drawer - Orange */
.filter-drawer:nth-of-type(3) .ant-drawer-header {
  background: #fa8c16;
}

.filter-drawer .ant-drawer-body {
  padding: 16px;
}

.filter-item-btn {
  height: 48px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.filter-item-btn:hover {
  background: #f0f0f0;
  border-color: #d9d9d9;
}

.product-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.product-card .ant-card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px;
  cursor: default;
}

.product-card .ant-card-body > div:first-child {
  flex-shrink: 0;
  margin-bottom: 8px;
}

.product-card .ant-card-body .ant-btn {
  height: 28px;
}

.product-image-container {
  position: relative;
  width: 100%;
  height: 150px;
  overflow: hidden;
  border-radius: 6px;
  background: #f5f5f5;
  /* border: 1px solid #d9d9d9; */
}

.product-card-img {
  height: 100% !important;
  width: 100% !important;
  object-fit: cover;
  border-radius: 6px;
}

/* Product Card Skeleton */
.product-card .ant-skeleton-image {
  border-radius: 8px;
}

  .product-image-container .ant-skeleton.ant-skeleton-element {
  width: 100%
}

.product-card .ant-skeleton-button {
  border-radius: 6px;
}

.product-card .ant-skeleton-input {
  border-radius: 4px;
}

.product-card-content {
  flex: 1 1;
  margin-bottom: 2px;
}

.product-name {
  font-size: 13px;
  font-weight: 600;
  margin: 0;
  color: #111111;
}

.product-sku {
  margin: 2px 0;
  color: #585858;
  font-size: 10px;
}

.product-price {
  margin: 2px 0;
  color: #111111;
  font-size: 14px;
  font-weight: 700;
}

.product-qty-tag {
  position: absolute !important;
  top: 0px !important;
  right: -7px !important;
  z-index: 1;
  font-size: 10px;
  font-weight: 600;
  border-radius: 4px;
  padding: 0px 4px;
  /* color: white !important; */
  /* background-color: #111111 !important; */
  /* border: none !important; */
}


/* Cart area */
.pos-cart {
  background: #fafafa;
  overflow-y: auto;
  width: 100%;
  height: 100%; /* ensure full height */
  display: flex;
  flex-direction: column;
  position: sticky; /* make cart sticky */
  top: 0;
} 

.cart-item-count {
  color: #111111 !important;
  cursor: default !important;
}

/* Content areas for proper scrolling */
.pos-products-content {
  flex: 1 1;
  overflow-y: auto;
  height: calc(100% - 60px); /* subtract header height */
  /* Custom scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;
}

.pos-products-content::-webkit-scrollbar {
  width: 6px;
}

.pos-products-content::-webkit-scrollbar-track {
  background: transparent;
}

.pos-products-content::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
  border-radius: 3px;
}

.pos-products-content::-webkit-scrollbar-thumb:hover {
  background-color: #bfbfbf;
}

.pos-cart-content {
  flex: 1 1;
  overflow-y: auto;
  height: calc(100% - 60px); /* subtract header height */
  /* Custom scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;
}

.pos-cart-content::-webkit-scrollbar {
  width: 6px;
}

.pos-cart-content::-webkit-scrollbar-track {
  background: transparent;
}

.pos-cart-content::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
  border-radius: 3px;
}

.pos-cart-content::-webkit-scrollbar-thumb:hover {
  background-color: #bfbfbf;
}

/* Cart Items Styling */
.cart-listing {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.cart-items-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
}

.cart-items-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fff;
  transition: all 0.2s ease;
}

.cart-item:hover {
  border-color: #d9d9d9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.cart-item .attribute-tag {
  background-color: #f0f0f0;
  color: #666;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  width: fit-content;
}

.cart-item-image {
  flex-shrink: 0;
}

.cart-item-placeholder {
  border: 1px dashed #d9d9d9;
}

.cart-item-info {
  min-width: 0; /* Allow text to wrap */
}

.cart-item-info h4 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  word-break: break-word;
}

.cart-item-info p {
  margin: 2px 0;
  font-size: 12px;
  color: #666;
}

/* Cart Item Content */
.cart-item-content {
  flex: 1 1;
}

/* Cart Item Image */
.cart-item-img {
  border-radius: 8px;
  object-fit: cover;
}

/* Cart Item Text Elements */
.cart-item-name {
  font-size: 13px;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.cart-item-qty {
  font-size: 12px;
  display: block;
  margin-bottom: 2px;
}

.cart-item-price {
  font-size: 12px;
  display: block;
  margin-bottom: 2px;
}

.cart-item-subtotal {
  font-size: 13px;
  color: #1890ff;
}

/* Cart Item Remove Button */
.cart-item-remove-btn {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: centr;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;
}

/* Cart Item Quantity Controls */
.cart-item-quantity-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  /* margin: 8px 0; */
}

.cart-item-qty-btn {
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background: #fff;
  transition: all 0.2s ease;
}

.cart-item-qty-btn:hover:not(:disabled) {
  border-color: #1890ff;
  color: #1890ff;
}

.cart-item-qty-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cart-item-qty-input {
  width: 50px;
  text-align: center;
}

.cart-item-qty-input .ant-input-number-input {
  text-align: center;
  padding: 0 8px;
}

/* Cart Item Layout Improvements */
.cart-item-content {
  flex: 1 1;
  min-width: 0;
}

.cart-item-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cart-item-name {
  font-size: 14px;
  font-weight: 600;
  color: #111111;
  line-height: 1.4;
  margin: 0;
}

.cart-item-price-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cart-item-price {
  font-size: 12px;
  color: #666;
  margin: 0;
}

.cart-item-subtotal {
  font-size: 13px;
  color: #1890ff;
  font-weight: 600;
  margin: 0;
}

.cart-item-right-controls {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  height: 100%;
  min-height: 60px;
  gap: 8px;
}

.cart-item-quantity-section {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
}

.cart-item-quantity-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #f5f5f5;
  border-radius: 6px;
  padding: 4px;
  border: 1px solid #e8e8e8;
}

.cart-item-qty-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.cart-item-qty-btn:hover:not(:disabled) {
  background-color: #e6f7ff;
  color: #1890ff;
}

.cart-item-qty-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cart-item-qty-input {
  width: 50px;
  text-align: center;
  border: none;
  background: transparent;
  font-weight: 600;
}

.cart-item-qty-input .ant-input-number-input {
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  padding: 0 4px;
}

/* Cart Item Loading State */
.cart-item .ant-spin-container {
  opacity: 1;
}

.cart-item .ant-spin {
  position: relative;
}

.cart-item .ant-spin-spinning .ant-spin-container {
  opacity: 0.6;
}

.cart-item .ant-spin-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

/* Discounts Component Styling */
.discounts-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  margin-top: 12px;
}

.discounts-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.discounts-title {
  margin: 0 !important;
  color: #111111;
  display: flex;
  align-items: center;
  gap: 8px;
}

.discounts-count {
  font-size: 12px;
  font-weight: 500;
}

.discounts-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
}

.discounts-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.discount-item {
  padding: 0 !important;
}

.discount-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  background: #fafafa;
  transition: all 0.2s ease;
}

.discount-card:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
  background: #fff;
}

.discount-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.discount-code-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.discount-code {
  font-size: 16px;
  font-weight: 600;
  color: #111111;
}

.discount-type-tag {
  font-weight: 600;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.discount-details {
  margin-bottom: 16px;
}

.discount-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.discount-info-row:last-child {
  margin-bottom: 0;
}

.discount-label {
  font-size: 12px;
  font-weight: 500;
  color: #666;
  min-width: 80px;
}

.discount-value {
  font-size: 12px;
  font-weight: 500;
  color: #111111;
  display: flex;
  align-items: center;
  gap: 4px;
}

.discount-actions {
  display: flex;
  justify-content: flex-end;
}

.apply-discount-btn {
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.apply-discount-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}

/* Recent Orders Modal Styling */
.recent-orders-modal .ant-modal-header {
  border-bottom: 1px solid #e8e8e8;
  padding: 0px 0px 16px 0px;
}

.recent-orders-modal .modal-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.recent-orders-controls {
  padding: 16px 16px;
  /* border-bottom: 1px solid #f0f0f0; */
  background: #fafafa;
  margin-bottom: 8px;
}

.search-control {
  width: 100%;
}

.search-input {
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  transition: all 0.2s ease;
}

.search-input:hover {
  border-color: #1890ff;
}

.search-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}

.filter-control {
  width: 100%;
}

.date-filter-select {
  width: 100%;
  border-radius: 8px;
}

.date-filter-select .ant-select-selector {
  border-radius: 8px !important;
  border: 1px solid #d9d9d9 !important;
  transition: all 0.2s ease !important;
}

.date-filter-select:hover .ant-select-selector {
  border-color: #1890ff !important;
}

.date-filter-select.ant-select-focused .ant-select-selector {
  border-color: #1890ff !important;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important;
}

.filter-info {
  text-align: right;
  padding: 8px 0;
}

.filter-info .ant-typography {
  font-size: 13px;
}

.recent-orders-content {
  padding: 0;
}

.empty-orders {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}

.recent-orders-table {
  margin-top: 0;
}

.recent-orders-table .ant-table-thead > tr > th {
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  font-weight: 600;
  color: #111111;
}

.recent-orders-table .ant-table-tbody > tr > td {
  border-bottom: 1px solid #f0f0f0;
  padding: 12px 16px;
}

.recent-orders-table .ant-table-tbody > tr:hover > td {
  background: #f5f5f5;
}

.table-header-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-icon {
  color: #1890ff;
}

.order-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.order-number {
  font-size: 14px;
  color: #111111;
}

.order-id {
  font-size: 12px;
  color: #666;
}

.customer-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.customer-name {
  font-size: 14px;
  color: #111111;
}

.customer-email {
  font-size: 12px;
  color: #666;
}

.date-info {
  display: flex;
  flex-direction: column;
}

.order-date {
  font-size: 13px;
  color: #111111;
}

.total-info {
  display: flex;
  flex-direction: column;
}

.order-total {
  font-size: 14px;
  color: #111111;
}

.status-tag {
  font-weight: 500;
  border-radius: 4px;
}

.load-order-btn {
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.load-order-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}

.view-invoice-btn {
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.view-invoice-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}

/* Payment Modal Styling */
.payment-modal .ant-modal-header {
  border-bottom: 1px solid #e8e8e8;
  padding: 0px 0px 16px 0px;
}

.payment-modal-content {
  padding: 0;
}

.payment-summary {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  /* margin-bottom: 16px; */
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summary-label {
  font-size: 16px;
  font-weight: 500;
  color: #111111;
}

.summary-value {
  font-size: 20px;
  font-weight: 700;
  color: #1890ff;
}

/* .internal-payment-content {
  padding-bottom: 16px;
} */

.cash-payment-section {
  margin-bottom: 20px;
}

.cash-input-group {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #e8e8e8;
}

.cash-input-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.cash-input-item:last-child {
  margin-bottom: 0;
}

.cash-label {
  font-size: 14px;
  font-weight: 500;
  color: #111111;
}

.cash-value {
  font-size: 16px;
  font-weight: 600;
  color: #1890ff;
}

.cash-received-input {
  width: 120px;
  text-align: right;
}

.cash-received-input .ant-input {
  text-align: right;
  font-weight: 600;
}

.change-item {
  padding-top: 8px;
  border-top: 1px solid #e8e8e8;
  margin-top: 8px;
}

.change-value.positive {
  color: #52c41a;
  font-weight: 700;
}

.change-value.negative {
  color: #ff4d4f;
  font-weight: 700;
}

.online-payment-section {
  margin-top: 20px;
}

.quick-amounts-section {
  margin-bottom: 16px;
}

.quick-amounts-title {
  font-size: 14px;
  font-weight: 500;
  color: #111111;
  margin-bottom: 8px;
  display: block;
}

.quick-amounts-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 12px;
}

.quick-amount-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
}

.quick-amount-btn {
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #111111;
  transition: all 0.2s ease;
}

.quick-amount-btn:hover:not(:disabled) {
  background: #f0f0f0;
  border-color: #40a9ff;
  color: #1890ff;
  transform: translateY(-1px);
}

.quick-amount-btn:active:not(:disabled) {
  transform: translateY(0);
  background: #e6f7ff;
}

.clear-cash-btn {
  width: 100%;
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  background: #ff4d4f;
  border-color: #ff4d4f;
  color: #fff;
  transition: all 0.2s ease;
}

.clear-cash-btn:hover:not(:disabled) {
  background: #ff7875;
  border-color: #ff7875;
  transform: translateY(-1px);
}

.clear-cash-btn:active:not(:disabled) {
  transform: translateY(0);
  background: #d9363e;
}

.amount-count-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #1890ff;
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.payment-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.payment-option-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.quick-cash-btn {
  background: #52c41a;
  border-color: #52c41a;
}

.quick-cash-btn:hover:not(:disabled) {
  background: #73d13d;
  border-color: #73d13d;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.3);
}

.online-payment-btn {
  background: #f5f5f5;
  border-color: #d9d9d9;
  color: #999;
  cursor: not-allowed;
}

.qr-code-section {
  text-align: center;
  padding: 20px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
}

.external-payment-content {
  padding: 0px 0;
}

.external-payment-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  /* margin-top: 16px; */
  transition: all 0.2s ease;
}

.external-payment-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

/* Payment Modal Tabs */
.payment-modal .ant-tabs-tab {
  padding: 12px 16px;
  font-weight: 500;
}

.payment-modal .ant-tabs-tab-active {
  color: #1890ff;
}

.payment-modal .ant-tabs-ink-bar {
  background: #1890ff;
}

.payment-modal .ant-tabs-content-holder {
  padding: 0;
}

/* Responsive adjustments for Payment Modal */
@media (max-width: 768px) {
  .payment-modal .ant-modal {
    width: 95% !important;
    max-width: 95% !important;
  }
  
  .payment-option-btn {
    height: 44px;
    font-size: 14px;
  }
  
  .external-payment-btn {
    height: 44px;
    font-size: 14px;
  }
  
  .qr-code-section {
    padding: 16px;
  }
  
  .summary-value {
    font-size: 18px;
  }
  
  .cash-input-group {
    padding: 12px;
  }
  
  .cash-received-input {
    width: 100px;
  }
  
  .cash-label {
    font-size: 13px;
  }
  
  .cash-value {
    font-size: 15px;
  }
  
  .quick-amounts-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
  }
  
  .quick-amount-btn {
    height: 36px;
    width: 100%;
    font-size: 13px;
  }
  
  .clear-cash-btn {
    height: 32px;
    font-size: 13px;
  }
  
  .amount-count-badge {
    width: 18px;
    height: 18px;
    font-size: 10px;
    top: -5px;
    right: -5px;
  }
}

/* Responsive adjustments for Recent Orders Modal */
@media (max-width: 768px) {
  .recent-orders-modal .ant-modal {
    width: 95% !important;
    max-width: 95% !important;
  }
  
  .recent-orders-controls {
    padding: 12px 16px;
  }
  
  .filter-info {
    text-align: center;
    margin-top: 8px;
  }
  
  .recent-orders-table .ant-table-thead > tr > th,
  .recent-orders-table .ant-table-tbody > tr > td {
    padding: 8px 12px;
  }
  
  .order-number,
  .customer-name,
  .order-total {
    font-size: 13px;
  }
  
  .order-id,
  .customer-email {
    font-size: 11px;
  }
  
  .view-invoice-btn {
    font-size: 12px;
    padding: 4px 8px;
  }
}

@media (max-width: 480px) {
  .recent-orders-controls .ant-row {
    flex-direction: column;
  }
  
  .recent-orders-controls .ant-col {
    margin-bottom: 12px;
  }
  
  .filter-info {
    text-align: left;
    margin-top: 0;
  }
}

.empty-cart {
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 200px; */
  color: #999;
  font-size: 14px;
  margin-top:28px;
}

/* Cart Order Options Styling */
.cart-order-options {
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}

.cart-order-options .ant-segmented {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 2px;
}

.cart-order-options .ant-segmented-item {
  font-size: 11px;
  font-weight: 500;
  padding: 6px 8px;
  border-radius: 4px !important;
  transition: all 0.2s ease;
}

/* .cart-order-options .ant-segmented-item-selected {
  background: #111111;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
} */

.cart-order-options .ant-segmented-item:hover:not(.ant-segmented-item-selected) {
  background: #e6e6e6;
  color: #333;
}

/* POS Customer Styling */
.pos-customer-section {
  padding: 12px 0px;
  padding-bottom: 0px;
  background: #fff;
}

.pos-customer-section .ant-form-item-label > label {
  font-size: 12px;
  font-weight: 500;
  color: #666;
}

.pos-customer-section .ant-input,
.pos-customer-section .ant-select-selector {
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.pos-customer-section .ant-input:focus,
.pos-customer-section .ant-select-focused .ant-select-selector {
  border-color: #111111;
  box-shadow: 0 0 0 2px rgba(17, 17, 17, 0.1);
}

.customer-details-section {
  /* margin-top: 8px; */
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.customer-details-section .ant-form-item {
  margin-bottom: 12px;
}

.customer-details-section .ant-input-prefix {
  color: #999;
}

.pos-customer-section .ant-select-item-option-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Cart Order Actions Styling */
.cart-order-actions {
  position: sticky;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 10px;
  padding-bottom: 0px;
  margin-top: auto;
}

.cart-details-section {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 6px;
}

.cart-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.cart-detail-item:last-child {
  margin-bottom: 0;
}

.cart-detail-label {
  font-size: 11px;
  color: #666;
  font-weight: 500;
}

.cart-detail-value {
  font-size: 11px;
  color: #333;
  font-weight: 600;
}

/* .cart-total-bar {
  background: #111111;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 8px;
} */

.cart-total-label {
  color: #111111;
  font-size: 13px;
  font-weight: 600;
}

.cart-total-amount {
  color: #111111;
  font-size: 13px;
  font-weight: 600;
}

.cart-action-buttons {
  margin-top: 6px;
}

.cart-buttons-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto auto;
  gap: 6px;
  max-width: 100%;
}

.cart-buttons-grid .cart-action-btn:nth-child(1) {
  grid-column: 1 / 1;
  grid-row: 1 / 1;
}

.cart-buttons-grid .cart-action-btn:nth-child(2) {
  grid-column: 1 / 2.5;
  grid-row: 1 / 1;
}

.cart-buttons-grid .cart-action-btn:nth-child(3) {
  grid-column: 1 / 3.5;
  grid-row: 1 / 1;
}

/* .cart-buttons-grid .cart-action-btn:nth-child(4) {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
} */

.cart-action-btn {
  height: 32px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: none;
  transition: all 0.2s ease;
  padding: 0 6px;
  min-width: 0;
}

.cart-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cart-action-btn:active {
  transform: translateY(0);
}

.cart-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.cart-action-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
}

.cart-action-btn span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.suspend-btn {
  background: #fff3cd;
  color: #856404;
  border: 1px solid  #ebc044;
}

.suspend-btn:hover {
  background: #ffeaa7;
  color: #856404;
}

.cash-payment-btn {
  background: #87ceeb;
  color: #1e3a8a;
  border: 1px solid #4682b4;
}

.cash-payment-btn:hover {
  background: #4682b4;
  color: white;
}

.payment-btn {
  background: #90ee90;
  color: #006400;
  border: 1px solid #32cd32;
}

.payment-btn:hover {
  background: #32cd32;
  color: white;
}

.cancel-btn {
  background: #ffb3ba;
  color: #8b0000;
  border: 1px solid #ff6b6b;
}

.cancel-btn:hover {
  background: #ff6b6b;
  color: white;
}


/* Suspended Cart Modal */
.suspended-cart-card {
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  padding: 20px;
  color: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
}

.suspended-cart-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border-color: #ffd666;
  background: #fff9d6;
}

.suspended-cart-card:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.suspended-cart-header {
  text-align: center;
  margin-bottom: 16px;
}

.suspended-cart-ref {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
}

.suspended-cart-customer {
  font-size: 12px;
  font-weight: 400;
  color: #666;
}

.suspended-cart-details {
  flex: 1 1;
}

.suspended-cart-detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.suspended-cart-detail-item:last-child {
  margin-bottom: 0;
}

.suspended-cart-detail-item svg {
  color: #faad14;
  flex-shrink: 0;
}

.suspended-cart-detail-item span {
  flex: 1 1;
  color: #333;
}

.suspended-cart-footer {
  margin-top: auto;
}

.suspended-by-info {
  text-align: center;
  padding: 4px 0;
}

.suspended-by-info .ant-typography {
  margin: 0;
}

/* Product Quick View Modal Styles */
.product-quick-view-modal .ant-modal-content {
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
}

.product-quick-view-modal .modal-header {
  position: sticky;
  top: 0;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
}

.product-quick-view-modal .modal-body {
  display: grid;
  gap: 16px;
  padding: 16px;
  grid-template-columns: 320px 1fr;
}

.product-quick-view-modal .product-image-section {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  max-height: 280px;
}

.product-quick-view-modal .image-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-quick-view-modal .product-details-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
}

.product-quick-view-modal .product-meta {
  margin-top: 12px;
}

.product-quick-view-modal .product-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.composite-products-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* .product-quick-view-modal .product-tabs .ant-tabs-tab {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #fff;
  margin-right: 8px;
} */

/* .product-quick-view-modal .product-tabs .ant-tabs-tab-active {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
} */

.product-quick-view-modal .pricing-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.product-quick-view-modal .price-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  font-size: 14px;
}

.product-quick-view-modal .price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.product-quick-view-modal .add-to-cart-section {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 12px;
  margin-top: 0px;
}

.product-quick-view-modal .quantity-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.product-quick-view-modal .quantity-controls .ant-btn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f3f4f6;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.product-quick-view-modal .quantity-controls .ant-btn:hover {
  background: #111111;
  color: #ffffff;
}


.product-quick-view-modal .quantity-controls .ant-input-number {
  width: 80px;
}

.product-quick-view-modal .quantity-controls .ant-input-number-input {
  text-align: center;
  padding: 4px 12px;
  border-radius: 10px;
  font-size: 18px;
}

.product-quick-view-modal .discounts-section,
.product-quick-view-modal .related-section {
  padding: 20px;
  text-align: center;
  color: #64748b;
}

/* Gift Card Section Styles */
.product-quick-view-modal .gift-card-section {
  padding: 0px 0;
}

.product-quick-view-modal .gift-card-info {
  margin-bottom: 20px;
  padding: 12px;
  background: #f6f8fa;
  border-radius: 8px;
  border-left: 4px solid #52c41a;
}

.product-quick-view-modal .gift-card-form {
  display: flex;
  flex-direction: column;
  /* gap: 16px; */
}

.product-quick-view-modal .gift-card-form .form-item {
  display: flex;
  flex-direction: column;
}

.product-quick-view-modal .gift-card-form .ant-input-number {
  width: 100%;
}

.product-quick-view-modal .gift-card-form .ant-input {
  width: 100%;
}

.product-quick-view-modal .gift-card-form .ant-select {
  width: 100%;
}

  .product-quick-view-modal .gift-card-form .ant-input-number-prefix {
    /* color: #52c41a; */
    font-weight: bold;
  }

  /* Variable Products Section Styles */
  .product-quick-view-modal .variable-products-section {
    padding: 0px 0px 0px 0;
  }

  .product-quick-view-modal .variable-products-header {
    margin-bottom: 8px;
  }

  .product-quick-view-modal .variable-products-table {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    overflow: hidden;
  }

  .product-quick-view-modal .variable-table .ant-table-thead > tr > th {
    background-color: #fafafa;
    font-weight: 600;
    border-bottom: 1px solid #f0f0f0;
  }

  .product-quick-view-modal .add-all-variables-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e8e8e8;
  }
/* 
  .product-quick-view-modal .add-all-variables-btn {
    height: 48px; 
    font-size: 16px; 
    border-radius: 8px; 
   background: #1890ff; 
   border-color: #1890ff;
    transition: all 0.2s ease;
  } */

  /* .product-quick-view-modal .add-all-variables-btn:hover:not(:disabled) {
    background: #40a9ff;
    border-color: #40a9ff;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  } */

  .product-quick-view-modal .variant-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .product-quick-view-modal .variant-name {
    font-weight: 600;
    color: #111111;
    font-size: 14px;
  }

  .product-quick-view-modal .variant-attributes {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  .product-quick-view-modal .attribute-tag {
    background-color: #f0f0f0;
    color: #666;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }

  .product-quick-view-modal .variant-price {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .product-quick-view-modal .sale-price {
    color: #52c41a;
    font-weight: 600;
    font-size: 14px;
  }

  .product-quick-view-modal .original-price {
    color: #999;
    text-decoration: line-through;
    font-size: 12px;
  }

  .product-quick-view-modal .regular-price {
    color: #111111;
    font-weight: 600;
    font-size: 14px;
  }

  .product-quick-view-modal .variant-stock {
    display: flex;
    align-items: center;
  }

  .product-quick-view-modal .stock-status {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }

  .product-quick-view-modal .stock-status.in-stock {
    background-color: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
  }

  .product-quick-view-modal .stock-status.out-of-stock {
    background-color: #fff2f0;
    color: #ff4d4f;
    border: 1px solid #ffccc7;
  }

  .product-quick-view-modal .stock-status.unlimited {
    background-color: #f0f0f0;
    color: #666;
    border: 1px solid #d9d9d9;
  }

  .product-quick-view-modal .variant-quantity-controls {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .product-quick-view-modal .variant-quantity-controls .ant-btn {
    width: 24px;
    height: 24px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-quick-view-modal .variant-quantity-controls .ant-input-number {
    width: 70px;
  }

  .product-quick-view-modal .variant-quantity-controls .ant-input-number-input {
    text-align: center;
    padding: 4px 8px;
  }

  /* Bill Styles */
  .pos-bill-wrapper {
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px;
  }

  .bill-actions {
    margin-bottom: 20px;
    padding: 16px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .bill-content {
    /* background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
    overflow: hidden;
  }

  .bill-container {
    padding: 30px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  /* Bill Header */
  .bill-header {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .company-info {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .bill-logo {
    height: 40px;
    width: auto;
    /* border-radius: 8px; */
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  }

  .company-name {
    margin: 0 !important;
    color: #111111;
    font-size: 28px;
    font-weight: 700;
  }

  .company-tagline {
    color: #666;
    font-size: 16px;
    margin-top: 4px;
  }

  .bill-info {
    text-align: right;
  }

  .bill-title-text {
    margin: 0 !important;
    color: #111111;
    font-size: 28px !important;
    font-weight: 600;
    /* letter-spacing: 1px; */
  }

  .bill-details {
    /* margin-top: 20px; */
    background-color: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    max-width: 280px;
    margin-left: auto;
  }

  .bill-detail-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 16px;
  }

  .bill-detail-row:last-child {
    margin-bottom: 0;
  }

  .bill-container .status-tag {
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
  }

  /* Bill Customer Details */
  .bill-customer-section {
    margin: 0;
  }

  .customer-details-card {
    height: 100%;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #e8e8e8;
  }

  .customer-details-card .ant-card-body {
    padding: 20px;
  }

  .customer-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
  }

  .customer-avatar {
    background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
    border: 3px solid #e6f7ff;
  }

  .customer-avatar.walk-in {
    background: linear-gradient(135deg, #fa8c16 0%, #ffa940 100%);
    border-color: #fff7e6;
  }

  .customer-avatar.no-customer {
    background: linear-gradient(135deg, #8c8c8c 0%, #bfbfbf 100%);
    border-color: #f5f5f5;
  }

  .customer-title-section {
    flex: 1 1;
  }

  .customer-title {
    margin: 0 !important;
    color: #111111;
    font-size: 18px;
    font-weight: 600;
  }

  .customer-type-tag {
    margin-top: 4px;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 12px;
  }

  .customer-divider {
    margin: 16px 0;
    border-color: #f0f0f0;
  }

  .customer-info-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .info-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    background-color: #fafafa;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
  }

  .info-item.full-width {
    grid-column: 1 / -1;
  }

  .info-icon {
    color: #1890ff;
    font-size: 16px;
    margin-top: 2px;
    flex-shrink: 0;
  }

  .info-content {
    flex: 1 1;
    min-width: 0;
  }

  .info-label {
    display: block;
    font-size: 12px;
    font-weight: 500;
    color: #8c8c8c;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .info-value {
    display: block;
    font-size: 14px;
    color: #111111;
    word-break: break-word;
  }

  /* Bill Items Table */
  .bill-items-section {
    margin: 0;
  }

  .modern-items-card {
    height: 100%;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #e8e8e8;
  }

  .modern-items-card .ant-card-body {
    padding: 0;
  }

  .items-header-modern {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px 16px;
    /* background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%); */
    border-radius: 12px 12px 0 0;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .items-title {
    margin: 0 !important;
    color: #111111;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .title-icon {
    color: #1890ff;
    font-size: 20px;
  }

  .items-count-tag {
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 16px;
    font-weight: 500;
  }

  .header-right {
    text-align: right;
  }

  .subtotal-preview {
    font-size: 14px;
    color: #666;
  }

  .items-divider {
    margin: 0;
    border-color: #f0f0f0;
  }

  .modern-items-table {
    border: none;
  }

  .modern-items-table .ant-table {
    border-radius: 0px !important;
    border: none !important;
  }

  .modern-items-table .ant-table-thead > tr > th {
    /* background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%); */
    font-weight: 600;
    color: #111111;
    /* border-bottom: 2px solid #e8e8e8; */
    padding: 16px 20px;
    font-size: 13px;
  }

  .table-header-cell {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .header-icon {
    color: #1890ff;
    font-size: 14px;
  }

  .modern-items-table .ant-table-tbody > tr > td {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
    height: 80px;
  }

  .modern-items-table .ant-table-tbody > tr {
    height: 80px;
  }

  .modern-items-table .ant-table-tbody > tr:hover > td {
    background-color: #f8f9fa;
  }

  .modern-item-info {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .item-image-container {
    flex-shrink: 0;
  }

  .modern-item-image {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #e8e8e8;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .modern-item-image .ant-image {
    width: 50px;
    height: 50px;
  }

  .modern-item-image .ant-image-img {
    width: 50px !important;
    height: 50px !important;
    object-fit: cover;
  }

  .modern-item-image .ant-image-mask {
    width: 50px !important;
    height: 50px !important;
  }

  .image-fallback {
    width: 50px;
    height: 50px;
    background-color: #f5f5f5;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fallback-icon {
    color: #bfbfbf;
    font-size: 20px;
  }

  .item-details-modern {
    flex: 1 1;
    min-width: 0;
  }

  .item-name-modern {
    margin-bottom: 8px;
  }

  .product-name {
    font-size: 15px;
    font-weight: 600;
    color: #111111;
    line-height: 1.4;
  }

  .item-meta {
    margin-top: 8px;
  }

  .sku-tag,
  .variant-tag {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 12px;
    font-weight: 500;
  }

  .price-cell,
  .quantity-cell,
  .subtotal-cell {
    text-align: right;
  }


  .subtotal-amount {
    font-size: 15px;
    font-weight: 600;
    color: #111111;
  }

  .quantity-tag {
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 16px;
    font-weight: 600;
  }

  /* Bill Summary */
  .bill-summary-section {
    margin: 24px 0;
  }

  .bill-summary-section .ant-row {
    margin-bottom: 16px;
  }

  .order-summary-card,
  .tip-card {
    background-color: #fafafa;
    border: 1px solid #f0f0f0;
    height: 100%;
    border-radius: 12px;
  }

  .order-summary-card .ant-card-head,
  .tip-card .ant-card-head {
    background-color: #f5f5f5;
    border-bottom: 1px solid #e8e8e8;
    padding: 16px 20px;
    border-radius: 12px 12px 0 0;
  }

  .order-summary-card .ant-card-head-title,
  .tip-card .ant-card-head-title {
    font-weight: 600;
    color: #111111;
    font-size: 16px;
  }

  .order-summary-card .ant-card-body,
  .tip-card .ant-card-body {
    padding: 20px;
  }

  .summary-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 8px 0;
  }

  .summary-item:last-child {
    margin-bottom: 0;
  }

  .tip-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  /* .tip-type-selector {
    margin-bottom: 16px;
  } */

  .quick-tip-options {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .tip-buttons {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  .tip-option-btn {
    height: 40px;
    font-weight: 500;
    border-radius: 8px;
  }

  .custom-tip-input {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .tip-summary {
    background-color: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
  }

  .total-payable-card {
    background: linear-gradient(135deg, #111111 0%, #333333 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    margin-top: 24px;
  }

  .total-payable-card .ant-card-body {
    padding: 20px 24px;
  }

  .summary-item.total-item {
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .summary-item.total-item .ant-typography {
    color: white !important;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    margin: 0 !important;
  }

  /* Bill Footer */
  .bill-footer-section {
    margin-top: 20px;
  }

  .payment-info {
    padding: 16px;
    text-align: center;
  }

  .bill-footer-bottom {
    margin-top: 20px;
    padding-top: 20px;
  }

  /* Print Styles */
  @media print {
    .no-print {
      display: none !important;
    }

    .pos-bill-wrapper {
      background: white;
      padding: 0;
    }

    .bill-content {
      box-shadow: none;
      border-radius: 0;
    }

    .bill-container {
      padding: 20px;
    }

    .bill-actions {
      display: none;
    }

    .bill-header {
      page-break-inside: avoid;
    }

    .bill-items-table {
      page-break-inside: avoid;
    }

    .bill-summary-section {
      page-break-inside: avoid;
    }
  }

  /* Responsive */
  @media (max-width: 768px) {
    .bill-container {
      padding: 20px;
    }

    .company-info {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    .bill-info {
      text-align: left;
      /* margin-top: 20px; */
    }

    .bill-title-text {
      font-size: 28px;
    }

    .bill-details {
      max-width: 100%;
      margin-left: 0;
    }

    .bill-item-info {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .item-image {
      align-self: center;
    }

    .tip-buttons {
      grid-template-columns: repeat(2, 1fr);
    }

    .order-summary-card .ant-card-body,
    .tip-card .ant-card-body {
      padding: 16px;
    }

    .bill-summary-section {
      margin: 20px 0;
    }

    .summary-item {
      margin-bottom: 10px;
      padding: 6px 0;
    }

    .tip-section {
      gap: 16px;
    }
  }

  @media (max-width: 480px) {
    .bill-container {
      padding: 16px;
    }

    .bill-title-text {
      font-size: 24px;
    }

    .company-name {
      font-size: 24px;
    }

    .tip-buttons {
      grid-template-columns: 1fr;
    }
  }

/* Responsive adjustments */
@media (max-width: 768px) {
  .suspended-cart-card {
    padding: 16px;
  }
  
  .suspended-cart-ref {
    font-size: 16px;
  }
  
  .suspended-cart-customer {
    font-size: 13px;
  }
  
  .suspended-cart-detail-item {
    font-size: 12px;
  }
  
  .product-quick-view-modal .modal-body {
    grid-template-columns: 1fr;
  }
  
  .product-quick-view-modal .product-image-section {
    min-height: 200px;
  }
}
/* Loyalty Points Section */
.loyalty-points-section {
  margin: 12px 0;
  padding: 10px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: 8px;
}

.loyalty-points-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.loyalty-points-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  flex: 1 1;
}

.loyalty-points-main {
  display: flex;
  align-items: center;
  gap: 8px;
}

.loyalty-points-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.loyalty-detail-row {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  gap: 8px;
}

.loyalty-detail-label {
  font-size: 10px;
  color: #0369a1;
  font-weight: 500;
}

.loyalty-detail-value {
  font-size: 10px;
  color: #0c4a6e;
  font-weight: 600;
}

.loyalty-points-label {
  font-size: 12px;
  color: #0369a1;
  font-weight: 500;
}

.loyalty-points-value {
  font-size: 12px;
  color: #0c4a6e;
  font-weight: 600;
}

.use-points-btn {
  background: #0369a1;
  border-color: #0369a1;
  color: #fff;
  font-weight: 500;
  border-radius: 6px;
  height: 32px;
  padding: 0 16px;
  transition: all 0.2s ease;
}

.use-points-btn:hover:not(:disabled) {
  background: #0284c7 !important;
  border-color: #0284c7 !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(3, 105, 161, 0.3);
}

.use-points-btn:disabled {
  background: #94a3b8;
  border-color: #94a3b8;
  color: #fff;
}

/* Redeemed Points Section */
.redeemed-points-section {
  margin: 12px 0;
  padding: 10px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 1px solid #bbf7d0;
  border-radius: 8px;
}

.redeemed-points-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.redeemed-points-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
}

.redeemed-points-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.redeemed-points-label {
  font-size: 12px;
  color: #166534;
  font-weight: 500;
}

.redeemed-points-value {
  font-size: 12px;
  color: #14532d;
  font-weight: 600;
}

.redeemed-discount-value {
  font-size: 12px;
  color: #16a34a;
  font-weight: 600;
}

.cancel-points-btn {
  color: #ef4444;
  background: transparent;
  border: none;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-width: auto;
  height: auto;
}

.cancel-points-btn:hover:not(:disabled) {
  background: #fef2f2 !important;
  color: #dc2626 !important;
  transform: scale(1.1);
}

.cancel-points-btn:disabled {
  color: #94a3b8;
  background: transparent;
}

/* POS end */
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8FAA8F;;AAE9F;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;GAWG;AACH;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;EAC3B,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;;;GAGG;AACH;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;AACH;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;GAKG;AACH;EACE,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;;EAEE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB;;;;;;;;;8EAS4E;AAC9E;;AAEA;EACE,yDAAuD;EACvD,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;;EAElB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yDAAkD;IAClD,4BAA4B;IAC5B,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;;;;IAIE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,yCAAyC;IACzC,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yDAAkD;IAClD,4BAA4B;IAC5B,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;;;IAIE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,yCAAyC;IACzC,mBAAmB;EACrB;AACF;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB;wBACsB;EACtB;wBACsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,WAAW;EACb;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,WAAW;EACb;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;;EAIE,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,MAAM;EACN,OAAO;EACP,kBAAkB;AACpB;;AAEA;;;;;EAKE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,oDAAoD;EACpD,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;GAGG;;AAEH;;;GAGG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;EAcE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;AACzB;AACA;;;EAGE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;;EAKE,SAAS;AACX;AACA;;;;;;;EAOE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA,qBAAqB;;AAErB,4BAA4B;AAC5B;EACE,+BAA+B;EAC/B,gBAAgB;;EAEhB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA,0BAA0B;;AAE1B,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,SAAS;EACT,kCAA0B;UAA1B,0BAA0B;EAC1B,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAA0B;UAA1B,0BAA0B;EAC1B,0CAA0C;EAC1C,iBAAiB;EACjB,sBAAsB;EACtB;wBACsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oGAAoG;EACpG,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA,0BAA0B;;AAE1B,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA,uBAAuB;;AAEvB,sBAAsB;AACtB;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,SAAS;EACT,QAAQ;AACV;;AAEA,oBAAoB;;AAEpB,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB,uBAAuB;AACvB;;;;EAIE,UAAU;AACZ;AACA,qBAAqB;;AAErB,2BAA2B;AAC3B;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;;EAElB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;;;;GAIG;;AAEH;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,yBAAyB;;AAEzB,wBAAwB;AACxB;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA,sBAAsB;;AAEtB,cAAc;AACd;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE;AACF;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;;;;;oBAKkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;EAME,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;;;;;;;;GAWG;;AAEH,YAAY;;AAEZ,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,yBAAyB,EAAE,WAAW;EACtC,cAAc,EAAE,cAAc;AAChC;AACA;EACE,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA,kBAAkB;;AAElB,iBAAiB;AACjB;;;EAGE,WAAW;AACb;AACA;;;;;EAKE,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,yCAAyC;AAC3C;AACA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA,eAAe;;AAEf,cAAc;;AAEd,gBAAgB;AAChB;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA,WAAW;AACX;EACE,cAAc,EAAE,sBAAsB;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,cAAc,EAAE,sBAAsB;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,SAAO,EAAE,0BAA0B;EACnC,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB,EAAE,8BAA8B;EAChD,0BAA0B,EAAE,2BAA2B;AACzD;AACA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY,EAAE,uBAAuB;EACrC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,SAAO,EAAE,yBAAyB;EAClC,gBAAgB,EAAE,yBAAyB;EAC3C,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH,4BAA4B;AAC5B;EACE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;AACV;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;EAEE;EACA;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,0CAA0C;EAC1C,6BAA6B;AAC/B;;;AAGA,cAAc;AACd;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY,EAAE,uBAAuB;EACrC,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,qBAAqB;EACvC,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB,EAAE,2BAA2B;EACtD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB,EAAE,2BAA2B;EACtD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY,EAAE,uBAAuB;AACvC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,SAAO;AACT;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA,6CAA6C;AAC7C;EACE;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;EACb;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;;GAIG;;AAEH;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;GAKG;;AAEH;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;;AAGA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yCAAyC;EACzC,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;;;GAMG;;AAEH;;;GAGG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;EAEE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;EAC/B;AACF;;;;;;;;KAQK;;EAEH;;;;;KAKG;;EAEH;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE;;+CAE2C;IAC3C,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA,gBAAgB;EAChB;IACE,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,8CAA8C;EAChD;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA,0BAA0B;EAC1B;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,6DAA6D;IAC7D,yBAAyB;EAC3B;;EAEA;IACE,6DAA6D;IAC7D,qBAAqB;EACvB;;EAEA;IACE,6DAA6D;IAC7D,qBAAqB;EACvB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;IACd,sBAAsB;EACxB;;EAEA,qBAAqB;EACrB;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,mEAAmE;IACnE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;EACzB;;EAEA;IACE,mEAAmE;IACnE,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;;IAGE,iBAAiB;EACnB;;;EAGA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;;IAEE,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;KAEG;;EAEH;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,6DAA6D;IAC7D,YAAY;IACZ,0CAA0C;IAC1C,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,yCAAyC;IACzC,oBAAoB;EACtB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,iBAAiB;EACjB;IACE;MACE,wBAAwB;IAC1B;;IAEA;MACE,iBAAiB;MACjB,UAAU;IACZ;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;EAEA,eAAe;EACf;IACE;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,gBAAgB;MAChB,sBAAsB;IACxB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ;IACV;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,qCAAqC;IACvC;;IAEA;;MAEE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,SAAS;IACX;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,0BAA0B;IAC5B;EACF;;AAEF,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA,2BAA2B;AAC3B;EACE,cAAc;EACd,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA,YAAY","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap'); */\n\nbody {\n  font-family: \"Inter\", sans-serif;\n  /* background-color: #f3f6f9; */\n  background: #fff;\n}\n\na {\n  color: inherit;\n}\n\n.no-spin-buttons::-webkit-outer-spin-button,\n.no-spin-buttons::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.no-spin-buttons {\n  -moz-appearance: textfield;\n}\n\n.suspenece-spin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.ant-form-item .ant-form-item-label > label {\n  font-size: 0.87rem;\n  color: #344054;\n}\n\n.ant-form-item .ant-form-item-explain,\n.ant-form-item .ant-form-item-extra {\n  font-size: 0.87rem;\n}\n\n.ant-upload-drag-container .ri-upload-cloud-2-fill {\n  font-size: 24px;\n  color: #9a9fb8;\n}\n\n.ant-card-contain-grid {\n  border-radius: 10px;\n}\n\n.ant-card .ant-card-grid-hoverable:hover {\n  position: relative;\n  z-index: 0;\n  box-shadow: none;\n}\n\n.font-14 {\n  font-size: 14px !important;\n}\n\n.font-16 {\n  font-size: 16px;\n}\n\n.font-18 {\n  font-size: 18px;\n}\n\n.font-22 {\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.fontW600 {\n  font-weight: 600;\n}\n\n.text-blue {\n  color: rgba(26, 55, 96, 0.88);\n}\n\n/* .ant-input {\n  padding: 9px 14px;\n  border: 1px solid #d0d5dd;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n}\n.ant-input.ant-input-sm {\n  padding: 4px 8px;\n}\n.ant-input::placeholder,\n.ant-select .ant-select-selection-placeholder {\n  color: #667085;\n} */\n.ant-layout {\n  background: transparent;\n}\n\n.ant-layout main {\n  padding: 40px;\n}\n\n.ant-layout-sider {\n  height: max-content;\n  min-height: 100vh;\n  border-right: 1px solid #eaecf0;\n  padding: 30px 20px;\n  position: sticky !important;\n  top: 0;\n}\n\n.anychart-credits {\n  display: none;\n}\n\n/* .ant-menu-inline .ant-menu-item {\n  height: 40px;\n  line-height: 40px;\n} */\n.ant-menu {\n  font-size: 14px;\n  padding: 16px 12px;\n}\n\n.ant-menu-light.ant-menu-root.ant-menu-inline,\n.ant-menu-light.ant-menu-root.ant-menu-vertical {\n  border: none;\n}\n\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-inline .ant-menu-submenu-title,\n.ant-menu-vertical .ant-menu-submenu-title {\n  padding-inline: 16px !important;\n}\n\n.ant-menu .ant-menu-item .ant-menu-item-icon + span,\n.ant-menu .ant-menu-submenu-title .ant-menu-item-icon + span,\n.ant-menu .ant-menu-item .anticon + span,\n.ant-menu .ant-menu-submenu-title .anticon + span {\n  margin-left: 8px;\n}\n\n.ant-menu-inline-collapsed\n  > .ant-menu-item-group\n  > .ant-menu-item-group-list\n  > .ant-menu-item\n  .ant-menu-item-icon {\n  font-size: 16px;\n}\n\n.ant-layout-sider .ant-menu-item {\n  margin-block: 2px !important;\n  height: 30px !important;\n}\n\n.ant-layout-sider .ant-menu-item-group-title {\n  padding: 6px 16px;\n}\n\n/* .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item {\n  padding: 8px 12px;\n} */\n.ant-message-notice {\n  text-align: right;\n  padding-right: 25px;\n  padding-top: 15px;\n}\n\n/* .ant-btn {\n  display: inline-flex;\n  padding: 10px 18px;\n  align-items: center;\n  justify-content: center;\n} */\n.ant-btn-primary {\n  box-shadow: 0 2px 2px rgb(1 9 14 / 15%);\n}\n\n.ant-table-cell-product + .ant-table-cell-product {\n  border-top: 1px solid #e8e8e8;\n}\n\n.ant-table-cell .ant-btn {\n  height: auto;\n  font-size: 12px;\n  padding: 4px 10px;\n  /* padding: 0px 8px; */\n  border-radius: 6px;\n}\n\n/* .ant-table-cell a:hover {\n  text-decoration: underline;\n} */\n\n.ant-btn [class^=\"ri-\"],\n.ant-btn [class*=\" ri-\"] {\n  display: inline-block;\n  margin-right: 3px;\n}\n\n.ant-btn.ant-btn-sm {\n  font-size: 12px;\n  height: 30px;\n}\n\n.ant-input-affix-wrapper .ant-input-prefix {\n  margin-right: 12px;\n  color: #667085;\n}\n\n.ant-table-wrapper:not(.table-inner) .ant-table {\n  border: 1px solid #d0d5dd;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n  border-radius: 8px;\n  overflow: auto;\n}\n\n.ant-table-wrapper.table-inside-card .ant-table {\n  border: none;\n  box-shadow: none;\n  /* border-radius: 0; */\n  margin-top: 1px;\n  border-start-start-radius: 0;\n  border-start-end-radius: 0;\n}\n\n.ant-table-wrapper.table-inside-card\n  .ant-table-container\n  table\n  > thead\n  > tr:first-child\n  > *:first-child {\n  border-start-start-radius: 0;\n}\n\n.ant-table-wrapper.table-inside-card\n  .ant-table-container\n  table\n  > thead\n  > tr:first-child\n  > *:last-child {\n  border-start-end-radius: 0;\n}\n\n.table-inside-card .ant-table-cell {\n  padding: 8px 12px !important;\n}\n\n.ant-table-wrapper.table-inside-card-addons .ant-table {\n  border: none;\n  box-shadow: none;\n  /* border-radius: 0; */\n  margin-top: 1px;\n  border-start-start-radius: 0;\n  border-start-end-radius: 0;\n}\n\n.ant-table-wrapper.table-inside-card-addons\n  .ant-table-container\n  table\n  > thead\n  > tr:first-child\n  > *:first-child {\n  border-start-start-radius: 0;\n}\n\n.ant-table-wrapper.table-inside-card-addons\n  .ant-table-container\n  table\n  > thead\n  > tr:first-child\n  > *:last-child {\n  border-start-end-radius: 0;\n}\n\n.table-inside-card-addons .ant-table-cell {\n  padding: 8px 12px !important;\n}\n\n.table-inside-card-addons .ant-table-row-indent + .ant-table-row-expand-icon {\n  margin-top: 0px !important;\n}\n\n.table-inside-card-addons .indent-level-1 + .ant-table-row-expand-icon {\n  visibility: hidden;\n}\n\n.page-listing .ant-table-row-indent + .ant-table-row-expand-icon {\n  margin-top: 0px !important;\n}\n\n.page-listing .indent-level-1 + .ant-table-row-expand-icon {\n  visibility: hidden;\n}\n\n.expand-warehouse-table .ant-table {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.profile-details-card {\n  border: 1px solid #e8e8e8 !important;\n}\n\n.profile-details-card .ant-card-body {\n  /* padding: 2rem 2.25rem; */\n  border-radius: 12px;\n}\n\n.profile-details-card .ant-card-body .title {\n  color: #030229;\n  font-weight: 500;\n  /* font-size: 16px; */\n}\n\n.status-tag {\n  padding: 4px 10px;\n  font-size: 0.8rem;\n  font-weight: normal;\n}\n\n.profile-details-card .details {\n  color: #030229;\n  font-weight: 400;\n  /* font-size: 16px; */\n}\n\n.title {\n  color: rgba(26, 55, 96, 0.88);\n  font-weight: 600;\n  /* font-size: 16px; */\n}\n\n.details {\n  color: #99a1b7;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.text-030229 {\n  color: #030229;\n}\n\n.text-03022903 {\n  color: #0302294d;\n}\n\n.card-title-custom .ant-card-head-title {\n  /* color: #030229; */\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.card-title-custom .ant-card-body {\n  border-radius: 12px;\n}\n\n.card-title-custom .ant-card {\n  border: 1px solid #e8e8e8;\n}\n\n.card-title-custom {\n  /* padding: 13px; */\n  border-radius: 12px;\n  border: 1px solid #e8e8e8 !important;\n}\n\n.ant-tabs-tab-btn {\n  /* font-size: 16px; */\n  color: rgba(26, 55, 96, 0.88);\n}\n\n.tabs-custom .status-icon-box {\n  width: 50px;\n  height: 50px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.tabs-custom .vendor-po-title {\n  color: #4f4e6a;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 2rem;\n  margin-bottom: 0;\n}\n\n.tabs-custom .vendor-po-desc {\n  color: #4f4e6a;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5rem;\n}\n\n.background-5B93FF {\n  background-color: #eff4ff;\n}\n\n.background-FFF7E1 {\n  background-color: #ffd56b3f;\n}\n\n.background-FFFBF9 {\n  background-color: #ff906b3a;\n}\n\n.border-bottom {\n  border-bottom: 0.5px solid #03022919;\n}\n\n/* customer details css end */\n.ant-row {\n  min-width: 100%;\n}\n\n.ant-steps-vertical .ant-steps-item {\n  padding-bottom: 50px;\n}\n\n.mt40 {\n  margin-top: 40px !important;\n}\n\n.mt6 {\n  margin-top: 6px;\n}\n\n.mt8 {\n  margin-top: 8px;\n}\n\n.mt10 {\n  margin-top: 10px;\n}\n\n.mt16 {\n  margin-top: 16px;\n}\n\n.mt20 {\n  margin-top: 20px;\n}\n\n.mt24 {\n  margin-top: 24px;\n}\n\n.mt30 {\n  margin-top: 30px;\n}\n\n.mt-2 {\n  margin-top: 2px;\n}\n\n.mb-9 {\n  margin-bottom: 9px;\n}\n\n.mb0 {\n  margin-bottom: 0 !important;\n}\n\n.mb28 {\n  margin-bottom: 28px;\n}\n\n.mb24 {\n  margin-bottom: 24px;\n}\n\n.mb16 {\n  margin-bottom: 16px;\n}\n\n.mb8 {\n  margin-bottom: 8px;\n}\n\n.mb2 {\n  margin-bottom: 2px;\n}\n\n.me4 {\n  margin-right: 12px;\n}\n\n.me1 {\n  margin-right: 4px;\n}\n\n.my10 {\n  margin: 10px 0;\n}\n\n.mx16 {\n  margin: 0 16px;\n}\n\n.mx26 {\n  margin: 0 26px;\n}\n\n.pt10 {\n  padding-top: 10px;\n}\n\n.pb16 {\n  padding-bottom: 16px;\n}\n\n.pb24 {\n  padding-bottom: 24px;\n}\n\n.p-4 {\n  padding: 4px;\n}\n\n.borderBottomDotted {\n  border-bottom: 1px dotted;\n}\n\n.linkHover:hover {\n  text-decoration: underline;\n}\n\n.borderBottom-ebebeb {\n  border-bottom: 1px solid #ebebeb;\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.fontWeight600 {\n  font-weight: 600;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.justify-content-center {\n  justify-content: center;\n}\n\n.justify-content-between {\n  justify-content: space-between;\n}\n\n.d-none {\n  display: none;\n}\n\n.d-block {\n  display: block;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.height-100 {\n  height: 100%;\n}\n\n.grid {\n  display: grid;\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.grid-cols4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.gap30 {\n  gap: 30px;\n}\n\n.mandatory-sign-mark::after {\n  display: inline-block;\n  margin-inline-end: 4px;\n  color: #ff4d4f;\n  font-size: 13px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: \"*\";\n  margin-left: 4px;\n}\n\n.login-container {\n  min-width: 100vw;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: #ffffff;\n  /* background-color: #f3f6f9; */\n  align-items: center;\n  /* background-color: #a099ff;\n  background-image: radial-gradient(at 48% 74%,\n      hsla(253, 90%, 67%, 1) 0px,\n      transparent 50%),\n    radial-gradient(at 85% 24%, hsla(269, 76%, 75%, 1) 0px, transparent 50%),\n    radial-gradient(at 55% 58%, hsla(39, 62%, 65%, 1) 0px, transparent 50%),\n    radial-gradient(at 85% 4%, hsla(262, 88%, 74%, 1) 0px, transparent 50%),\n    radial-gradient(at 10% 1%, hsla(184, 84%, 60%, 1) 0px, transparent 50%),\n    radial-gradient(at 39% 5%, hsla(13, 83%, 78%, 1) 0px, transparent 50%),\n    radial-gradient(at 51% 9%, hsla(288, 71%, 77%, 1) 0px, transparent 50%); */\n}\n\n.login-banner-wrapper-full {\n  background-image: url(\"./images/login-banner-full.png\");\n  background-repeat: no-repeat;\n  height: calc(100vh - 50px);\n  width: 100%;\n  background-size: cover;\n  background-position: left;\n  border-radius: 8px;\n}\n\n.login-card-new-full {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 28px;\n  margin: 60px auto;\n  max-width: 400px;\n  row-gap: 30px;\n}\n\n.login-card-new-full .logo {\n  width: 200px;\n}\n.login-card-new-full .welcome-title-full {\n  font-size: 24px;\n  color: #000000;\n}\n\n.login-wrapper-full {\n  padding: 24px;\n}\n\n.login-card {\n  width: 100%;\n  margin-top: 50px;\n  border: 1px solid #e3e6e9;\n  padding: 10px;\n  border-radius: 10px;\n  background-color: #fff;\n}\n\n.login-card-new {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  margin: 0 auto;\n  max-width: 400px;\n  min-width: 380px;\n  row-gap: 30px;\n}\n\n.login-card .logo {\n  width: 120px;\n}\n\n.login-card-new .logo {\n  width: 130px;\n}\n\n.login-banner {\n  border-radius: 24px;\n  height: calc(100vh - 40px);\n  object-fit: cover;\n  width: 100%;\n}\n\n.login-logo {\n  width: 200px;\n}\n\n.sidebar-custom-wrap {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.header-user-card-container {\n  border-radius: 6px;\n\n  padding: 5px 10px;\n}\n.login-card-new > .login-form-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n@media all and (min-width: 1200px) {\n  .header-user-card-container {\n    min-width: 180px;\n    background-color: #f4f4f4;\n  }\n}\n@media all and (device-width: 1024px) and (orientation: landscape) {\n  .login-wrapper {\n    padding: 40px;\n  }\n  .login-banner-wrapper {\n    display: none;\n  }\n  .login-card-wrapper {\n    border-radius: 30px;\n    background-color: #f2f5fd;\n    background-image: url(\"images/login-img-ipad.svg\");\n    background-repeat: no-repeat;\n    background-size: 100%;\n    background-position: center center;\n    height: calc(100vh - 40px);\n    width: calc(100vw - 40px);\n    display: flex;\n    align-items: top;\n    padding-top: 80px;\n    justify-content: center;\n    z-index: 999;\n  }\n\n  .login-card-new > .login-form-wrapper .logo {\n    width: 200px;\n  }\n  .login-card-new > .login-form-wrapper {\n    align-items: center;\n  }\n  .login-card-new > .login-form-wrapper .welcome-title {\n    font-size: 38px;\n  }\n  .login-card-new {\n    max-width: 300px;\n    width: 100%;\n  }\n  .login-card-new .ant-btn-lg {\n    font-size: 18px;\n  }\n  .login-wrapper.login-wrapper-old\n    .login-card-new\n    > .login-form-wrapper\n    .welcome-title {\n    font-size: 22px;\n  }\n  .login-wrapper.login-wrapper-old .login-card-new {\n    max-width: 450px;\n  }\n  .login-wrapper.login-wrapper-old .login-card-new form {\n    width: 100%;\n    background: #ffff;\n    padding: 40px;\n    box-shadow: 0px 4px 98.2px 32px #00000012;\n    border-radius: 17px;\n  }\n}\n@media all and (device-width: 768px) and (orientation: portrait) {\n  .login-wrapper {\n    padding: 40px;\n  }\n  .login-banner-wrapper {\n    display: none;\n  }\n  .login-card-wrapper {\n    border-radius: 30px;\n    background-color: #f2f5fd;\n    background-image: url(\"images/login-img-ipad.svg\");\n    background-repeat: no-repeat;\n    background-size: 100%;\n    background-position: bottom center;\n    height: calc(100vh - 40px);\n    width: calc(100vw - 40px);\n    display: flex;\n    align-items: top;\n    padding-top: 80px;\n    justify-content: center;\n    z-index: 999;\n  }\n  .login-card-new {\n    max-width: 500px;\n    width: 100%;\n  }\n  .login-card-new > .login-form-wrapper .logo {\n    width: 200px;\n  }\n  .login-card-new > .login-form-wrapper {\n    align-items: center;\n  }\n  .login-card-new > .login-form-wrapper .welcome-title {\n    font-size: 38px;\n  }\n  .login-card-new .ant-btn-lg {\n    font-size: 18px;\n  }\n  .login-wrapper.login-wrapper-old\n    .login-card-new\n    > .login-form-wrapper\n    .welcome-title {\n    font-size: 22px;\n  }\n  .login-wrapper.login-wrapper-old .login-card-new {\n    max-width: 450px;\n  }\n  .login-wrapper.login-wrapper-old .login-card-new form {\n    width: 100%;\n    background: #ffff;\n    padding: 40px;\n    box-shadow: 0px 4px 98.2px 32px #00000012;\n    border-radius: 17px;\n  }\n}\n\n.header-user-card {\n  /* border: 1px solid #d0d5dd;  */\n  border-radius: 8px;\n  /* padding: 10px; */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.user-details {\n  max-width: 110px;\n}\n\n.user-details-wrap {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 8px;\n  align-items: center;\n}\n\n.user-details-name {\n  font-size: 12px;\n  /* color: #1a3760; */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: bold;\n}\n\n.user-details-email {\n  font-size: 10px;\n  /* color: #1a3760; */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.page-header-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  /* padding-left: 16px;\n  padding-right: 16px; */\n  /* padding-left: 8px;\n  padding-right: 10px; */\n  padding-left: 7px;\n  padding-right: 17px;\n}\n\n.page-header-wrapper .page-header-title {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.page-header-wrapper .page-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n@media all and (device-width: 1024px) and (orientation: landscape) {\n  .page-header-wrapper {\n    flex-direction: column;\n    align-items: baseline;\n    gap: 20px;\n    padding: 0 20px;\n    margin-bottom: 10px;\n  }\n  .page-header-wrapper .page-header-title > div {\n    margin-left: 0 !important;\n  }\n  .page-header-wrapper .page-header-action,\n  .page-header-wrapper .page-header-actions {\n    width: 100%;\n  }\n  .page-header-wrapper .page-header-action > div {\n    justify-content: space-between;\n  }\n}\n@media all and (device-width: 768px) and (orientation: portrait) {\n  .page-header-wrapper {\n    flex-direction: column;\n    align-items: baseline;\n    gap: 20px;\n    padding: 0 20px;\n    margin-bottom: 10px;\n  }\n  .page-header-wrapper .page-header-title > div {\n    margin-left: 0 !important;\n  }\n  .page-header-wrapper .page-header-action,\n  .page-header-wrapper .page-header-actions {\n    width: 100%;\n  }\n  .page-header-wrapper .page-header-action > div {\n    justify-content: space-between;\n  }\n}\n.search-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 350px;\n}\n\n.card-checkbox .ant-checkbox-wrapper {\n  border-radius: 8px;\n  border: 1px solid #d0d5dd;\n  padding: 15px 28px 15px 10px;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.card-checkbox .ant-checkbox-wrapper .ant-checkbox {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}\n\n.card-checkbox .ant-checkbox-wrapper .ant-checkbox .ant-checkbox-inner,\n.card-checkbox .ant-checkbox-checked:after {\n  border-radius: 100%;\n}\n\n.card-checkbox\n  .ant-checkbox-wrapper\n  .ant-checkbox:not(.ant-checkbox-checked)\n  .ant-checkbox-inner {\n  border-color: transparent;\n}\n\n.card-checkbox .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {\n  background-color: #e6f4ff;\n  border-color: #1677ff;\n  border-width: 2px;\n  padding: 14px 27px 14px 9px;\n  /* border-width: 2px; */\n}\n\n.report_type_checkboxes .ant-checkbox-wrapper {\n  padding: 15px 28px 15px 28px;\n}\n\n.report_type_checkboxes .ant-checkbox + span {\n  width: 100%;\n  text-align: center;\n}\n\n.report_type_checkboxes .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {\n  padding: 14px 27px 14px 27px;\n}\n\n.marketplace-region {\n  color: #8996a9;\n}\n\n.antd-table-filter-dropdown {\n  padding: 15px 10px;\n  min-width: 200px;\n  display: flex;\n  justify-content: center;\n}\n\n.appplied-filter-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.applied-filter-tag {\n  font-size: 10px;\n  font-weight: 400;\n}\n\n.applied-filter-value {\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.applied-filters-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  flex-grow: 1;\n}\n\n.applied-filter-wrap {\n  padding: 8px;\n  background-color: #ffffff;\n  color: #132237;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height: auto;\n  border: 1px solid #e3e6e9;\n}\n\n.applied-filter-wrap > span {\n  cursor: pointer;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.applied-filter {\n  font-weight: bold;\n}\n\n.applied-filter > span {\n  font-size: 10px;\n  font-weight: normal;\n  margin-right: 10px;\n}\n\n.applied-filter-wrap .applied-filter-remove {\n  display: flex;\n  align-items: flex-start;\n  margin-left: 5px;\n  cursor: pointer;\n}\n\n.detail-block {\n  line-break: anywhere;\n}\n\n.detail-block > label,\n.detail-block > span {\n  display: block;\n}\n\n.detail-block > label {\n  font-size: 14px;\n  color: #667085;\n  margin-bottom: 3px;\n}\n\n.detail-block > span {\n  font-size: 18px;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.marketplace-detail-card,\n.report-type-wrapper {\n  border-radius: 8px;\n  border: 1px solid #d0d5dd;\n  padding: 15px 28px 15px 10px;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  align-items: center;\n  position: relative;\n  font-weight: normal;\n  text-align: center;\n}\n\n.report-type-wrapper {\n  font-size: 14px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding: 18px 20px;\n  width: 100%;\n  white-space: nowrap;\n}\n\n.table-tag .ant-alert {\n  display: inline-flex;\n  padding: 4px 8px;\n}\n\n.table-tag .ant-alert .ant-alert-content {\n  font-size: 12px;\n}\n\n.product-image-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.product-image-wrapper {\n  width: 102px;\n  height: 102px;\n  padding: 8px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n}\n\n.product-image-wrapper-sm {\n  width: 50px;\n  height: 50px;\n  padding: 5px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n}\n\n.product-title {\n  font-size: 16px;\n}\n\n.product-price {\n  color: #1677ff;\n}\n\n.product-compatibility-image {\n  /* border: 1px solid rgba(235, 235, 235, 1); */\n  min-height: 80px;\n  min-width: 80px;\n  /* object-fit: cover; */\n  object-fit: contain;\n  /* border-radius: 6px; */\n  aspect-ratio: 1 / 1;\n}\n\n.detail-block > label {\n  /* font-weight: 600; */\n}\n\n.detail-block ul {\n  padding-inline-start: 16px;\n  list-style-type: decimal;\n}\n\n.detail-block ul li {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.pd-identifier {\n  color: #667085;\n  margin-bottom: 10px;\n  display: block;\n}\n\n.pd-product-name {\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.ant-descriptions-item-content ul {\n  padding-left: 18px;\n}\n\n.pd-status-wrap {\n  display: inline-block;\n  margin-bottom: 20px;\n}\n\n.amazon-serach-modal-search\n  .ant-input-group\n  .ant-input-group-addon\n  .ant-select {\n  margin: 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px 0 0 8px;\n  border-right: 0px;\n}\n\n.amazon-serach-modal-search .ant-input-group .ant-input-group-addon {\n  padding: 0;\n  border: 0;\n}\n\n.amazon-serach-modal-search .ant-input-group .ant-input {\n  height: 46px;\n}\n\n.amazon-serach-modal-search .ant-input-group .ant-input-group-addon .ant-btn {\n  border-radius: 0 8px 8px 0;\n  border-left: 0;\n  height: 46px;\n}\n\n.read-more-btn {\n  background-color: transparent;\n  border: none;\n  color: #8996a9;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n@media all and (min-width: 576px) {\n  .login-card {\n    width: 480px;\n    padding: 40px;\n    padding-bottom: 50px;\n  }\n}\n\n.ant-checkbox-wrapper {\n  align-items: center;\n}\n\n.ant-form-item-required::before {\n  order: 1;\n  margin-right: 0;\n  margin-left: 4px;\n}\n\n.ant-list-bordered {\n  overflow: hidden;\n}\n\n.prdouct-info-btn {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.password-field label {\n  width: 100%;\n}\n\n.password-field .password-field-label {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ant-form-item .ant-form-item-label > label::after {\n  display: none;\n}\n\n.password-field .ant-form-item-extra {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translateY(-100%);\n}\n\n.ant-layout .ant-layout-sider-light {\n  background-color: #ffffff;\n  padding: 0;\n  /* border: 0; */\n}\n\n.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper,\n.ant-layout-header {\n  height: 56px;\n}\n\n.ant-layout-header {\n  position: sticky;\n  top: 0;\n  display: flex;\n  align-items: center;\n  line-height: 1.25;\n  padding: 0 16px;\n  z-index: 1;\n  border-bottom: 1px solid #eaecf0;\n}\n\n.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper {\n  padding: 5px 16px;\n}\n\n.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper img {\n  max-height: 100%;\n  margin: 0;\n}\n\n.ant-layout-sider .ant-menu-item {\n  font-weight: 500;\n}\n\n.ant-pagination .ant-pagination-item {\n  border-radius: 6px;\n}\n\n.ant-card {\n  box-shadow: rgba(26, 26, 26, 0.07) 0px 1px 0px 0px;\n  border: 1px solid rgb(204, 204, 204, 0.5);\n}\n\n.ant-picker {\n  width: 100%;\n}\n\n.ant-list-bordered {\n  background-color: #fff;\n}\n\n.address-make-default-btn {\n  opacity: 0;\n  transition-duration: 0.3s;\n}\n\n.ant-collapse-header:hover .address-make-default-btn {\n  opacity: 1;\n}\n\n.ant-upload-wrapper.ant-upload-picture-card-wrapper\n  .ant-upload-list.ant-upload-list-picture-card\n  .ant-upload-list-item-thumbnail\n  img {\n  aspect-ratio: 1/1;\n}\n\n.ant-upload-list {\n  margin-top: 8px;\n}\n\n.ant-upload-wrapper.ant-upload-picture-card-wrapper\n  .ant-upload-list.ant-upload-list-picture-card\n  .ant-upload-list-item-container,\n.ant-upload-wrapper.ant-upload-picture-card-wrapper\n  .ant-upload.ant-upload-select {\n  width: 80px;\n  height: 80px;\n}\n\n.ant-upload-wrapper\n  .ant-upload-list.ant-upload-list-picture-card\n  .ant-upload-list-item {\n  border-radius: 8px;\n  padding: 6px;\n}\n\n.ant-upload-wrapper\n  .ant-upload-list.ant-upload-list-picture-card\n  .ant-upload-list-item\n  .ant-upload-list-item-thumbnail {\n  border-radius: 4px;\n}\n\n.ant-upload-wrapper.ant-upload-picture-card-wrapper\n  .ant-upload-list.ant-upload-list-picture-card\n  .ant-upload-list-item::before {\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  top: 0;\n  left: 0;\n  border-radius: 6px;\n}\n\n.ant-upload-wrapper\n  .ant-upload-list\n  .ant-upload-list-item\n  .ant-upload-list-item-actions\n  .ant-upload-list-item-action.ant-btn-sm {\n  padding: 10px 5px;\n  width: auto;\n  height: auto;\n  background-color: #ffffff29;\n  border: 1px solid #ffffff50;\n}\n\n.ant-menu-sub.ant-menu-inline .ant-menu-item {\n  padding-left: 38px !important;\n}\n\n.form-remove-btn {\n  margin-top: 32px;\n  font-size: 18px;\n}\n\n.ql-toolbar.ql-snow {\n  border-radius: 8px 8px 0 0;\n  padding: 5px 3px;\n  font-family: \"Inter\", sans-serif;\n}\n\n.ql-toolbar.ql-snow .ql-picker-label {\n  border-radius: 5px;\n}\n\n.ql-toolbar.ql-snow .ql-picker-options {\n  border-radius: 8px;\n}\n\n.ql-container {\n  font-family: \"Inter\", sans-serif;\n}\n\n.ql-container.ql-snow {\n  border-radius: 0 0 8px 8px;\n}\n\n.ql-editor {\n  min-height: 5rem;\n  max-height: 30rem;\n  overflow-y: auto;\n}\n\n.hamburger-responsive {\n  /* border: 1px solid #4c535e; */\n  background-color: #2b2f35;\n  height: 37px;\n  width: 37px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 18px;\n}\n\n.nav-logo-responsive {\n  max-height: 37px;\n  width: auto;\n}\n\n.form-tab-section {\n  margin: 24px 0px;\n}\n\n.form-tab-section .ant-tabs-nav {\n  margin-bottom: 0px;\n  /* z-index: 1; */\n  /* border-bottom: 1px solid rgb(204, 204, 204, 0.5); */\n}\n\n.form-tab-section .ant-tabs-tabpane > .ant-card {\n  background: transparent;\n  border-top-right-radius: 0%;\n  border-top-left-radius: 0%;\n  /* border-top: none; */\n  position: relative;\n  /* z-index: -1; */\n}\n\n.form-tab-section .ant-tabs-tab-active {\n  background: #f3f6f9 !important;\n  border: 1px solid rgb(204, 204, 204, 0.5) !important;\n  border-bottom: none !important;\n}\n\n.form-tab-section .ant-tabs-nav {\n  position: sticky;\n  top: 56px;\n}\n\n.form-tab-section .ant-tabs-top > .ant-tabs-nav::before {\n  border-bottom-color: rgb(204, 204, 204, 0.5);\n}\n\n.form-tab-section .ant-tabs-nav-wrap {\n  background: #f3f6f9;\n}\n\n.form-tab-section .ant-tabs-tab-active::after {\n  position: absolute;\n  right: 0;\n  left: 0;\n  bottom: -4px;\n  /* border-bottom: 3px solid #172539; */\n  border: 3px solid #f3f6f9;\n  content: \"\";\n  /* z-index: 2; */\n}\n\n.header-user-card-container {\n  cursor: pointer;\n}\n\n.ant-menu-sub .ant-menu-item {\n  height: 28px;\n  line-height: 28px;\n}\n\n.ant-menu-submenu-open {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n.ant-menu-inline-collapsed .ant-menu-item-group-title {\n  opacity: 0;\n  /* height: ; */\n}\n\n.ant-menu-item-group:not(:first-child) {\n  margin-top: 0px;\n}\n\n.sidebar-responsive {\n  font-size: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  padding: 0;\n  border: 1px solid #eee;\n}\n\n.ant-menu-light.ant-menu-root.ant-menu-inline {\n  overflow-y: auto;\n}\n\n.table-cell-link {\n  font-weight: 700;\n}\n\n/* .table-cell-link:hover {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n} */\n\n.table-cell-product-image {\n  border: 1px solid rgba(235, 235, 235, 1);\n  min-height: 40px;\n  min-width: 40px;\n  /* object-fit: cover; */\n  object-fit: contain;\n  aspect-ratio: 1 / 1;\n  border-radius: 6px;\n}\n\n.ant-table-cell-with-append {\n  /* display: flex; */\n  align-items: center;\n}\n\n.ant-table-wrapper:not(.table-inner)\n  .ant-table-row-indent\n  + .ant-table-row-expand-icon {\n  border-color: #1a3760e0;\n  margin-top: 12px;\n}\n\n.ant-table-wrapper.expand-without-image\n  .ant-table-row-indent\n  + .ant-table-row-expand-icon {\n  display: none;\n}\n\n/* .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n  background: rgb(26 55 96 / 7%);\n  border: none;\n} */\n\n/* .ant-tabs > .ant-tabs-nav .ant-tabs-nav-add {\n  border: none;\n  background: rgb(26 55 96 / 7%);\n} */\n\n.purchase-order-table {\n  margin-top: 12px;\n}\n\n.purchase-order-table.ant-table-wrapper .ant-table {\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.purchase-order-table.ant-table-wrapper .ant-table-container,\n.purchase-order-table.ant-table-wrapper .ant-table-container table,\n.purchase-order-table.ant-table-wrapper\n  .ant-table-container\n  table\n  > thead\n  > tr:first-child\n  > *:first-child,\n.purchase-order-table.ant-table-wrapper\n  .ant-table-container\n  table\n  > thead\n  > tr:first-child\n  > *:last-child {\n  border-radius: 0;\n}\n\n.purchase-order-table .ant-table-cell {\n  vertical-align: top;\n}\n\n.recieve-order-progress .ant-progress .ant-progress-success-bg {\n  background-color: rgba(41, 132, 90, 1);\n}\n\n.recieve-order-progress .ant-progress-bg {\n  background-color: rgba(181, 38, 11, 1);\n}\n\n.inventory-unavaible-card .ant-card-body {\n  padding: 4px;\n}\n\n.inventory-unavaible-card .ant-card-head {\n  padding: 4px;\n  min-height: auto;\n}\n\n.order-user-card .ant-card {\n  border: 0px;\n  box-shadow: none;\n  padding: 0;\n  border-radius: 0;\n}\n\n.order-user-card .ant-card:hover {\n  border: 0px;\n  box-shadow: none;\n  padding: 0;\n  border-radius: 0;\n}\n\n.order-user-card .ant-card .ant-card-body {\n  padding: 8px;\n  border-radius: 0;\n}\n\n.order-user-link-card .ant-card {\n  border: 0px;\n  box-shadow: none;\n  padding: 0;\n  border-radius: 0;\n}\n\n.order-user-link-card .ant-card:hover {\n  border: 0px;\n  box-shadow: none;\n  padding: 0;\n  border-radius: 0;\n}\n\n.order-user-link-card .ant-card .ant-card-body {\n  padding: 8px;\n  border-radius: 0;\n}\n\n.collection-product-table .ant-table-container .ant-table-thead {\n  display: none;\n}\n\n.collection-product-table {\n  margin-top: 24px;\n}\n\n.comment-section .comment-section-input {\n  border: none;\n  padding-left: 0;\n}\n\n.comment-section\n  .ant-input-status-error:not(.ant-input-disabled):not(\n    .ant-input-borderless\n  ).ant-input:focus,\n.comment-section .ant-input:focus {\n  box-shadow: none;\n}\n\n.comment-section .ant-card-small > .ant-card-body {\n  padding: 0;\n}\n\n.comment-section .comment-section-top {\n  padding: 12px;\n}\n\n.comment-section .comment-section-bottom {\n  padding: 12px;\n  background-color: #f3f6f9;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.comment-section-block {\n  position: absolute;\n  inset-block-start: 0px;\n  inset-inline-start: 4px;\n  height: 40px;\n  border-inline-start: 2px solid rgba(5, 5, 5, 0.06);\n}\n\n.log-inventory_received .ant-table-wrapper:not(.table-inner) .ant-table {\n  border: none;\n  box-shadow: none;\n  border-radius: 0px;\n  overflow: auto;\n}\n\n.log-inventory_received .ant-table-wrapper .ant-table-thead > tr > th,\n.log-inventory_received .ant-table-wrapper .ant-table-thead > tr > td {\n  position: relative;\n  color: rgba(26, 55, 96, 0.88);\n  font-weight: 600;\n  text-align: start;\n  background: transparent;\n  border-bottom: none;\n}\n\n.log-inventory_received .ant-table-wrapper .ant-table {\n  background: transparent;\n}\n\n.log-inventory_received .ant-table-wrapper .ant-table-tbody > tr > td {\n  border-bottom: none;\n}\n\n.log-inventory_received\n  .ant-table-wrapper\n  .ant-table-thead\n  > tr\n  > th:not(:last-child):not(.ant-table-selection-column):not(\n    .ant-table-row-expand-icon-cell\n  ):not([colspan])::before {\n  background-color: transparent;\n}\n\n.log-inventory_received .log-inventory_received-description:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.log-inventory_received .log-inventory_received-arrow:hover {\n  cursor: pointer;\n}\n\n.log-inventory_received .log-inventory_received-description-container {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mt3 {\n  margin-top: 3px;\n}\n\n/* product page start */\n.product-add-page .ant-select-selector .ant-select-selection-search-input {\n  height: 50px !important;\n}\n.product-add-page\n  .ant-select-multiple.ant-select-lg\n  .ant-select-selection-item {\n  height: 40px !important;\n}\n.product-variation-table {\n  margin-top: 24px;\n}\n.product-variation-table.ant-table-wrapper\n  .ant-table-tbody\n  > tr\n  > td.ant-table-cell {\n  padding: 2px 8px;\n}\n.product-variation-table.ant-table-wrapper\n  .ant-table-tbody\n  > tr\n  > td.ant-table-cell\n  .ant-form-item {\n  margin: 0;\n}\n.product-variation-table\n  .ant-upload-wrapper.ant-upload-picture-card-wrapper\n  .ant-upload-list.ant-upload-list-picture-card\n  .ant-upload-list-item-container,\n.product-variation-table\n  .ant-upload-wrapper.ant-upload-picture-card-wrapper\n  .ant-upload.ant-upload-select {\n  width: 60px;\n  height: 60px;\n}\n\n.product-variation-table .ant-upload-select strong {\n  font-weight: 400;\n}\n.product-variation-table .ant-table {\n  overflow: unset !important;\n  overflow-y: hidden !important;\n  overflow-x: auto !important;\n}\n/* product page end */\n\n/* cms page form css start */\n.dashed-border {\n  /* border:1px dashed #8996a9; */\n  margin-top: 20px;\n\n  border-top: 1px dashed #8996a9;\n}\n\n.form-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333333;\n  margin-bottom: 8px;\n}\n\n.form-description {\n  font-size: 14px;\n  font-weight: 400;\n  color: #666666;\n}\n\n.form-box {\n  background-color: white;\n  padding: 32px;\n}\n\n/* cms page form css end */\n\n/* sticky footer css start */\n.sticky-footer {\n  position: sticky;\n  bottom: 0;\n  backdrop-filter: blur(9px);\n  background-color: rgba(243, 244, 246, 0.1);\n  text-align: right;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  margin-left: -2rem;\n  margin-right: -2rem;\n  z-index: 999;\n}\n\n.sticky-footer-padding {\n  position: sticky;\n  bottom: 0;\n  backdrop-filter: blur(9px);\n  background-color: rgba(243, 244, 246, 0.1);\n  text-align: right;\n  padding: 1.5rem 3.2rem;\n  /* padding-left: 2rem;\n  padding-right: 2rem; */\n  margin-left: -2rem;\n  margin-right: -2rem;\n}\n\n.ant-card .ant-card-actions > li {\n  margin: 4px 0;\n}\n\n.ant-card .ant-card-head-title {\n  overflow: visible;\n}\n\n.google-places-autocomplete {\n  margin-bottom: 24px;\n}\n\n.google-places-autocomplete div[class$=\"control\"]::before {\n  width: 24px;\n  height: 24px;\n  content: \"\";\n  background-image: url(\"https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg\");\n  background-size: 24px 24px;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  pointer-events: none;\n}\n\n.google-places-autocomplete div[class$=\"control\"] {\n  border-width: 1px;\n  border-style: solid;\n  border-color: #d9d9d9;\n  border-radius: 8px;\n  transition: all 0.2s;\n  min-height: 32px;\n  height: auto;\n  padding-left: 32px;\n}\n\n.google-places-autocomplete div[class$=\"indicatorContainer\"] {\n  padding: 6px;\n}\n\n.google-places-autocomplete div[class$=\"Input\"] {\n  margin: 0;\n}\n\n/* sticky footer css end */\n\n/* filter section start */\n.filter-section {\n  margin: 16px 0px;\n}\n\n.filter-section .ant-card .ant-card-body {\n  padding: 4px;\n}\n\n.filter-section .ant-btn.ant-btn-sm {\n  padding: 5.5px 8px;\n}\n\n.filter-section .ant-btn.ant-btn-sm.ant-btn-text {\n  padding: 5.5px 12px;\n  font-weight: 600;\n}\n\n.filter-section-head {\n  border-bottom: 1px solid rgb(204, 204, 204, 0.5);\n  padding: 10px 10px 10px 10px;\n}\n\n/* filter section end */\n\n/* Vendor View start */\n.vendor-tabs .ant-tabs-nav {\n  margin: 0;\n}\n\n.vendor-tabs .ant-tabs-tab {\n  padding: 0px 0px 12px 0px;\n}\n\n.status-icon-box {\n  width: 50px;\n  height: 50px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.vendor-po-title {\n  color: #4f4e6a;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 2rem;\n}\n\n.vendor-po-desc {\n  color: #4f4e6a;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5rem;\n}\n\n.background-fff7e6 {\n  background-color: #fff7e6;\n}\n\n.background-eff5ff {\n  background-color: #eff5ff;\n}\n\n.background-ffe9e1 {\n  background-color: #ffe9e1;\n}\n\n.vendor-table .ant-table-wrapper .ant-table-thead > tr > th {\n  border-top: 1px solid #f0f0f0;\n  /* background: #E8E8E8; */\n}\n\n.vendor-table\n  .ant-table-wrapper\n  .ant-table-thead\n  > tr\n  > th:not(:last-child):not(.ant-table-selection-column):not(\n    .ant-table-row-expand-icon-cell\n  ):not([colspan])::before {\n  height: 0;\n  width: 0;\n}\n\n/* Vendor View end */\n\n/* Settings Start */\n.header-setting .menu-icon-box {\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.header-setting .menu-title {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 2rem;\n  margin-bottom: 0;\n}\n\n.background-ff6b6b3a {\n  background-color: #ff8b8b3a;\n  color: rgb(235 29 29);\n}\n\n.background-6bff6b3a {\n  background-color: #80ff803a;\n  color: #15b41e;\n}\n\n.background-5572a3 {\n  background-color: #5572a324;\n  color: #5572a3;\n}\n\n.background-648cff {\n  background-color: #e0e6ef;\n  color: #648cff;\n}\n\n/* Settings end */\n\n/* Order Refund Start */\n.order-refunds-table\n  > .ant-collapse-item\n  > .ant-collapse-content\n  > .ant-collapse-content-box {\n  padding: 0;\n}\n/* Order Refund End */\n\n/* Add Order Screen Start */\n.add-order-spin {\n  height: 40vh;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.add-order-container {\n  margin-top: 20px;\n}\n\n.total-container {\n  padding: 20px 20px 0px 20px;\n}\n\n.total-container .main-title {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.add-order-container .ant-card-body {\n  height: 100%;\n}\n\n.no-address-available {\n  /* border: 1px dashed gray; */\n  height: 20vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.add-order-container .product-image {\n  border: 1px solid rgba(235, 235, 235, 1);\n  min-height: 80px;\n  min-width: 80px;\n  /* object-fit: cover; */\n  object-fit: contain;\n  border-radius: 6px;\n  aspect-ratio: 1 / 1;\n  z-index: 0;\n  width: 100%;\n}\n.add-order-container .ant-image {\n  width: 100%;\n}\n\n.add-order-container .product-price {\n  color: #ffffff;\n  background-color: #b12525;\n  width: fit-content;\n  padding: 0px 8px;\n  border-radius: 4px;\n  position: absolute;\n\n  z-index: 1;\n}\n\n.add-order-container .product-quantity {\n  color: #027a48;\n  background-color: #ecfdf3;\n  width: fit-content;\n  padding: 0px 8px;\n  border-radius: 4px;\n  position: absolute;\n  z-index: 1;\n  right: 12px;\n}\n\n.checkout-address .ant-radio-checked + span > .ant-card {\n  border-color: #b12525;\n}\n\n.checkout-address .ant-radio {\n  display: none;\n}\n\n.checkout-address .ant-radio + span {\n  padding-inline-start: 0px;\n  padding-inline-end: 0px;\n  height: 100%;\n  width: 100%;\n}\n.checkout-address .ant-radio-wrapper {\n  margin-inline-end: 0px;\n  height: 100%;\n  width: 100%;\n}\n.checkout-address .ant-radio-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cart-drawer-btn {\n  background-color: #b12525;\n  display: flex;\n  flex-direction: column;\n  border: none;\n  box-shadow: none;\n  padding: 14px 12px 12px 12px;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  position: fixed;\n  right: 0;\n  top: 45%;\n  z-index: 999;\n}\n\n.cart-drawer-btn .cart-total-item {\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n}\n\n.cart-drawer-btn .cart-price {\n  background-color: #ffffff;\n  padding: 8px;\n  margin-top: 12px;\n  border-radius: 5px;\n  color: #b12525;\n  font-size: 14px;\n  font-weight: 600;\n  width: 100%;\n}\n\n.cart-total-item {\n  color: #b12525;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n}\n\n.cart-drawer .ant-drawer-body {\n  position: relative;\n  /* overflow: initial; */\n}\n\n.cart-drawer-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 24px;\n  overflow-y: auto;\n}\n\n.cart-drawer-total {\n  position: sticky;\n  bottom: 0;\n  background-color: #ffffff;\n  width: 100%;\n}\n\n.cart-drawer-product-image {\n  border: 1px solid rgba(235, 235, 235, 1);\n  min-height: 50px;\n  min-width: 50px;\n  object-fit: contain;\n  aspect-ratio: 1 / 1;\n  border-radius: 6px;\n}\n\n.shipping-service .ant-radio-checked + span > .ant-card {\n  border-color: #b12525;\n}\n\n.shipping-service .ant-radio {\n  display: none;\n}\n\n.shipping-service .ant-radio + span {\n  display: block;\n  width: 100%;\n  padding-inline-start: 0px;\n  padding-inline-end: 0px;\n}\n\n.default-btn-style .ant-btn-default {\n  background: #ffffff;\n  border-color: #b12525;\n  color: rgba(17, 17, 17, 0.88);\n  box-shadow: 0 2px 0 rgba(17, 17, 17, 0.02);\n}\n\n/* .default-btn-style .ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover{\n  color: #bd4a46;\n    border-color: #d9d9d9;\n    background: #ffffff;\n} */\n\n.add-to-cart-title {\n  margin-bottom: 24px;\n  color: #b12525;\n  font-size: 1.5rem;\n  line-height: 2rem;\n  text-align: center;\n}\n\n.text-modal-b12525 {\n  color: #b12525;\n}\n\n.add-to-cart-mt-4 {\n  margin-top: 24px;\n}\n.add-to-cart-mb-2 {\n  margin-bottom: 8px;\n}\n\n.core-refund-text {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  margin-bottom: 8px;\n}\n\n.core-refund-text-radio {\n  font-size: 14px;\n}\n\n.order-management-product-image {\n  border: 1px solid rgba(235, 235, 235, 1);\n  min-height: 50px;\n  min-width: 50px;\n  object-fit: contain;\n  aspect-ratio: 1 / 1;\n  border-radius: 6px;\n}\n\n.order-product-collapse .ant-collapse-content-box {\n  padding: 6px 0px !important;\n}\n.order-product-collapse .ant-collapse-header {\n  padding: 4px 0px !important;\n  padding-inline-start: 0px;\n}\n\n/* Add Order Screen End */\n\n/* Shipping Zone start */\n.no-form-input-label .ant-form-item-label label {\n  color: transparent;\n}\n.no-form-input-label .ant-form-item-label .ant-form-item-required::before {\n  color: transparent !important;\n}\n/* Shipping Zone end */\n\n/* CMS start */\n.ant-picker {\n  width: 100%;\n}\n\n.ant-upload-list {\n  margin-bottom: 8px;\n}\n\n.ant-upload-picture-card-wrapper .ant-upload-drag {\n  margin-bottom: 16px;\n}\n\n.ant-upload-list-item-thumbnail,\n.ant-upload-list .ant-upload-list-item-container .ant-upload-list-item::before {\n  border-radius: 10px;\n}\n\n.ant-tag {\n  padding: 4px 10px;\n  font-size: 10px;\n}\n\n.table-cell-product-image {\n  border-radius: 7px;\n}\n\n.ant-form-item .ant-form-item-label > label::before {\n  order: 1;\n  margin-left: 4px;\n  margin-right: 4px;\n}\n\n.ant-form-item .ant-form-item-label > label::after {\n  order: 2;\n}\n\n.media-wrapper {\n  aspect-ratio: 1;\n  border: 1px solid #ccc;\n  border-radius: 16px;\n}\n\n.media-wrapper .ant-image {\n  width: 100%;\n  border-radius: 16px;\n  height: 100%;\n  cursor: pointer;\n}\n\n.ant-modal-body .media-wrapper-selected {\n  position: relative;\n}\n\n.ant-modal-body .media-wrapper-selected::after {\n  content: \"✓\";\n  font-size: 20px;\n  position: absolute;\n  color: #fff;\n  z-index: 2;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.ant-modal-body .media-wrapper-selected::before {\n  content: \"\";\n  height: 40px;\n  width: 40px;\n  background-color: #9d0d93;\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  transform: translate(-50%, -50%);\n  border-radius: 20px;\n}\n\n.media-wrapper-selected {\n  outline: 2px solid #9d0d93;\n  border: 1px solid #fff;\n  position: relative;\n}\n\n.media-wrapper-selected .ant-image {\n  opacity: 0.3;\n}\n\n.media-wrapper-selected::before {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n}\n\n/* .ant-image .ant-image-mask {\n  display: none;\n}*/\n.media-preview {\n  border: 1px solid #ccc;\n  max-width: 150px;\n  aspect-ratio: 1;\n  border-radius: 16px;\n}\n\n.media-preview {\n  object-fit: contain;\n}\n\n.media-preview ~ .ant-image-mask {\n  border-radius: 16px;\n}\n\n.media-wrapper .ant-image .ant-image-mask:hover {\n  opacity: 0;\n}\n\n.media-wrapper .ant-image .ant-image-img,\n.media-wrapper .ant-image .ant-image-mask {\n  border-radius: 16px;\n}\n\n.media-wrapper .ant-image .ant-image-img {\n  height: 100%;\n  object-fit: contain;\n}\n\n.toolbar-wrapper {\n  /* position: fixed;\n  bottom: 32px;\n  left: 50%;\n  padding: 0px 24px;\n  color: #fff;\n  font-size: 20px; */\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 100px;\n  /* transform: translateX(-50%);  */\n}\n\n.toolbar-wrapper .anticon {\n  padding: 12px;\n  cursor: pointer;\n}\n\n.toolbar-wrapper .anticon[disabled] {\n  cursor: not-allowed;\n  opacity: 0.3;\n}\n\n.toolbar-wrapper .anticon:hover {\n  opacity: 0.3;\n}\n\n.media-wrapper .ant-skeleton-element,\n.media-wrapper .ant-skeleton-element .ant-skeleton-image {\n  width: 100%;\n  height: 100%;\n  border-radius: 16px;\n}\n\n.ql-disabled {\n  color: rgba(17, 17, 17, 0.25);\n  background-color: rgba(17, 17, 17, 0.04);\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n/* Update Profile Css */\n\n.popOverIcon {\n  position: absolute;\n  top: -17px !important;\n  left: -50px !important;\n}\n\n.popOverIcon .ant-popover {\n  left: 80px !important;\n  top: -5px !important;\n}\n\n.popOverIcon .ant-popover .ant-popover-content .ant-popover-inner {\n  padding: 4px 8px !important;\n}\n\n.popOverIcon\n  .ant-popover\n  .ant-popover-content\n  .ant-popover-inner\n  .ant-popover-inner-content\n  .uploadDeleteBtn {\n  display: flex;\n  gap: 10px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.popOverIcon .editIcon {\n  width: 26px;\n  height: 26px;\n  border-radius: 13px;\n  border: 1px solid transparent;\n  position: absolute;\n  left: 40px;\n  top: 8px !important;\n  background: #ffffff;\n  box-shadow: 0px 0px 3.35509px rgba(0, 0, 0, 0.25);\n  padding: 4px;\n}\n\n.uploadBtn,\n.deleteBtn {\n  border: none;\n}\n\n/* .btnCmsPageCard{\n  all: unset;\n}\n\n.btnCmsPageCard:disabled,\n btnCmsPageCard[disabled]{\n  color: rgba(17, 17, 17, 0.25);\n  border-color: #d9d9d9;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n} */\n\n/* CMS end */\n\n/* Dashboard start */\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.dashboard-header .page-title-wrapper .page-header-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #111111e0;\n  margin-bottom: 6px;\n}\n.dashboard-header .page-title-wrapper .page-header-description {\n  font-size: 12px;\n  font-weight: 400;\n  color: #00000073;\n}\n.dashboard-components .ant-card,\n.dashboard-components .ant-card-body {\n  width: 100%;\n}\n.dashboard-components .mb10 {\n  margin-bottom: 10px;\n}\n.dashboard-components .analytics-icon-box {\n  padding: 18px;\n  padding-bottom: 14px;\n  border-radius: 8px;\n  width: fit-content;\n}\n.dashboard-components .color-orders {\n  background-color: #e6f4ff;\n  color: #4f90d4;\n}\n.dashboard-components .color-net-sales {\n  background-color: #cefcd67a;\n  color: #48aa5a;\n}\n.dashboard-components .color-average-order-value {\n  background-color: #fff7e6;\n  color: #d46b08;\n}\n.dashboard-components .color-average-item-per-order {\n  background-color: #dbc4ff61;\n  color: #6232b1;\n}\n.dashboard-components .color-registered-customers {\n  background-color: #ffbcbc3d;\n  color: #b12525;\n}\n.dashboard-components .color-conversion-rate {\n  background-color: #b7ffff63;\n  color: #008080;\n}\n.dashboard-components .analytics-title {\n  font-size: 14px;\n  color: #11111173;\n  font-weight: 400;\n}\n.dashboard-components .analytics-value {\n  font-size: 22px;\n  color: #111111e0;\n  font-weight: 500;\n}\n.dashboard-components .main-card-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111111e0;\n  margin-bottom: 0px;\n}\n.dashboard-components .live-user-count {\n  font-size: 48px;\n  font-weight: 600;\n  color: #111111e0;\n  margin-bottom: 4px;\n  margin-top: 12px;\n  text-align: center;\n  line-height: normal;\n}\n.dashboard-components .live-user-count-description {\n  color: #00000073;\n  text-align: center;\n  font-weight: 400;\n  font-size: 12px;\n}\n.dashboard-components .order-fulfilment-chart-container .apexcharts-canvas {\n  margin: 0 auto;\n}\n\n.dashboard-filter {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.dashboard-filter .ant-select {\n  min-width: 120px;\n  /* max-width: 100%; */\n  width: 100%;\n  max-width: 130px;\n}\n\n.custom-info-alert {\n  margin-top: 10px;\n  padding: 14px;\n  background: transparent !important;\n}\n.custom-info-alert.ant-alert-info {\n  background-color: #e6f4ff; /* light blue background */\n  border: 1px solid #91caff; /* border */\n  color: #1677ff; /* text/icon */\n}\n.custom-info-alert.ant-alert-info .ant-alert-icon {\n  color: #1677ff; /* force the icon color */\n}\n\n.announcement-card .ant-timeline-item-head-blue {\n  color: #1677ff !important;\n  border-color: #1677ff !important;\n}\n/* Dashboard end */\n\n/* Report start */\n.report-tab-container .ant-tabs-nav-wrap,\n.report-tab-container .ant-tabs-nav-list,\n.report-tab-container .ant-tabs-tab {\n  width: 100%;\n}\n.report-tab-container\n  .ant-tabs-card.ant-tabs-top\n  > .ant-tabs-nav\n  .ant-tabs-tab\n  + .ant-tabs-tab {\n  margin-left: 16px;\n}\n.report-tab-container .ant-tabs-tab {\n  padding: 12px !important;\n  border-radius: 8px 8px 0 0 !important;\n  background: rgb(50 50 50 / 2%) !important;\n}\n.report-tab-container .ant-tabs-tab-active {\n  border-bottom-color: #f0f0f0 !important;\n  background: #fff !important;\n}\n.report-tab-container .ant-tabs-nav {\n  margin: 0px;\n}\n.report-tab-container .ant-tabs-content-holder {\n  border: 1px solid #f0f0f0;\n  border-top: 0px;\n  border-radius: 0px 0px 8px 8px;\n}\n.report-tab-container .graph-title {\n  font-size: 14px;\n}\n/* Report end */\n\n/* POS start */\n\n/* POS Wrapper */\n.pos-order-wrapper {\n  background: #fff;\n  height: 100vh; \n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n\n/* Header */\n.pos-header {\n  flex-shrink: 0; /* prevent shrinking */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* padding: 12px 16px; */\n  border-bottom: 1px solid #f0f0f0;\n  background: #fafafa;\n}\n\n.pos-logo {\n  height: 40px;\n  object-fit: contain;\n  margin: 8px 16px;\n  margin-right: 0px;\n}\n\n/* POS User Welcome */\n.pos-user-welcome {\n  padding: 8px 12px;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.pos-user-welcome:hover {\n  background: rgba(17, 17, 17, 0.05);\n}\n\n.pos-user-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.pos-welcome-text {\n  font-size: 14px;\n  color: #666;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pos-user-name {\n  color: var(--ant-primary-color, #111111);\n  font-weight: 600;\n}\n\n.pos-dropdown-arrow {\n  color: #999;\n  transition: transform 0.3s ease;\n}\n.pos-cart-header {\n  flex-shrink: 0; /* prevent shrinking */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  background: #fafafa;\n}\n.pos-cart-header .page-header-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--ant-primary-color, #111111);\n  letter-spacing: 0.3px;\n}\n\n/* Actions on the right */\n.pos-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-right: 16px;\n}\n\n.pos-header-actions .ant-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 4px;\n  height: 44px;\n}\n\n.pos-header-action-text {\n  font-size: 9px;\n  font-weight: 400;\n}\n\n/* POS main layout */\n.pos-main {\n  flex: 1; /* take remaining height */\n  display: flex;\n  background: #fff;\n  border: 1px solid #f0f0f0;\n  border-top: none;\n  overflow: hidden; /* prevent double scrollbars */\n  height: calc(100vh - 60px); /* subtract header height */\n}\n/* Products area */\n.pos-products {\n  border-right: 1px solid #f0f0f0;\n  background: #ffffff;\n  overflow-y: auto;\n  width: 100%;\n  height: 100%; /* ensure full height */\n  display: flex;\n  flex-direction: column;\n}\n\n.product-listing {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  /* margin: 16px 0px; */\n  padding: 16px;\n  flex: 1; /* take remaining space */\n  overflow-y: auto; /* make this scrollable */\n  /* Custom scrollbar styling */\n  scrollbar-width: thin;\n  scrollbar-color: #d9d9d9 transparent;\n}\n\n.product-listing::-webkit-scrollbar {\n  width: 6px;\n}\n\n.product-listing::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.product-listing::-webkit-scrollbar-thumb {\n  background-color: #d9d9d9;\n  border-radius: 3px;\n}\n\n.product-listing::-webkit-scrollbar-thumb:hover {\n  background-color: #bfbfbf;\n}\n\n/* .product-filters {\n  margin-bottom: 16px;\n} */\n\n/* Floating Filter Buttons */\n.floating-filters {\n  position: fixed;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  z-index: 1000;\n  padding: 8px 0;\n}\n\n.filter-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 110px;\n  border-radius: 0 8px 8px 0;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  color: white;\n  font-size: 10px;\n  font-weight: 600;\n  text-align: center;\n  padding: 8px 4px;\n  gap: 8px;\n}\n\n/* Categories Button - Light Blue */\n.filter-btn:nth-child(1) {\n  background: #e6f7ff;\n  color: #1890ff;\n  border: 1px solid #91d5ff;\n}\n\n.filter-btn:nth-child(1):hover {\n  background: #91d5ff;\n  color: #1890ff;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(24, 144, 255, 0.3);\n}\n\n.filter-btn:nth-child(1).active {\n  background: #1890ff;\n  color: white;\n  box-shadow: 0 6px 20px rgba(24, 144, 255, 0.4);\n}\n\n/* Brands Button - Light Green */\n.filter-btn:nth-child(2) {\n  background: #f6ffed;\n  color: #52c41a;\n  border: 1px solid #b7eb8f;\n}\n\n.filter-btn:nth-child(2):hover {\n  background: #b7eb8f;\n  color: #52c41a;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(82, 196, 26, 0.3);\n}\n\n.filter-btn:nth-child(2).active {\n  background: #52c41a;\n  color: white;\n  box-shadow: 0 6px 20px rgba(82, 196, 26, 0.4);\n}\n\n/* Catalogs Button - Light Orange */\n.filter-btn:nth-child(3) {\n  background: #fff7e6;\n  color: #fa8c16;\n  border: 1px solid #ffd591;\n}\n\n.filter-btn:nth-child(3):hover {\n  background: #ffd591;\n  color: #fa8c16;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(250, 140, 22, 0.3);\n}\n\n.filter-btn:nth-child(3).active {\n  background: #fa8c16;\n  color: white;\n  box-shadow: 0 6px 20px rgba(250, 140, 22, 0.4);\n}\n\n.filter-btn .anticon {\n  margin: 0;\n  font-size: 16px;\n}\n\n.filter-text {\n  font-size: 11px;\n  line-height: 1.1;\n  /* text-transform: uppercase; */\n  letter-spacing: 1px;\n  writing-mode: vertical-rl;\n  /* text-orientation: upright; */\n  font-weight: 600;\n}\n\n/* Active Filters */\n.active-filters {\n  margin-top: 12px;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n/* Filter Drawer Styling */\n.filter-drawer .ant-drawer-header {\n  border-bottom: none;\n}\n\n.filter-drawer .ant-drawer-title {\n  color: white;\n  font-weight: 600;\n}\n\n.filter-drawer .ant-drawer-close {\n  color: white;\n}\n\n/* Category Drawer - Blue */\n.filter-drawer:nth-of-type(1) .ant-drawer-header {\n  background: #1890ff;\n}\n\n/* Brand Drawer - Green */\n.filter-drawer:nth-of-type(2) .ant-drawer-header {\n  background: #52c41a;\n}\n\n/* Catalog Drawer - Orange */\n.filter-drawer:nth-of-type(3) .ant-drawer-header {\n  background: #fa8c16;\n}\n\n.filter-drawer .ant-drawer-body {\n  padding: 16px;\n}\n\n.filter-item-btn {\n  height: 48px;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.filter-item-btn:hover {\n  background: #f0f0f0;\n  border-color: #d9d9d9;\n}\n\n.product-card {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n}\n\n.product-card .ant-card-body {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 8px;\n  cursor: default;\n}\n\n.product-card .ant-card-body > div:first-child {\n  flex-shrink: 0;\n  margin-bottom: 8px;\n}\n\n.product-card .ant-card-body .ant-btn {\n  height: 28px;\n}\n\n.product-image-container {\n  position: relative;\n  width: 100%;\n  height: 150px;\n  overflow: hidden;\n  border-radius: 6px;\n  background: #f5f5f5;\n  /* border: 1px solid #d9d9d9; */\n}\n\n.product-card-img {\n  height: 100% !important;\n  width: 100% !important;\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n/* Product Card Skeleton */\n.product-card .ant-skeleton-image {\n  border-radius: 8px;\n}\n\n  .product-image-container .ant-skeleton.ant-skeleton-element {\n  width: 100%\n}\n\n.product-card .ant-skeleton-button {\n  border-radius: 6px;\n}\n\n.product-card .ant-skeleton-input {\n  border-radius: 4px;\n}\n\n.product-card-content {\n  flex: 1;\n  margin-bottom: 2px;\n}\n\n.product-name {\n  font-size: 13px;\n  font-weight: 600;\n  margin: 0;\n  color: #111111;\n}\n\n.product-sku {\n  margin: 2px 0;\n  color: #585858;\n  font-size: 10px;\n}\n\n.product-price {\n  margin: 2px 0;\n  color: #111111;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.product-qty-tag {\n  position: absolute !important;\n  top: 0px !important;\n  right: -7px !important;\n  z-index: 1;\n  font-size: 10px;\n  font-weight: 600;\n  border-radius: 4px;\n  padding: 0px 4px;\n  /* color: white !important; */\n  /* background-color: #111111 !important; */\n  /* border: none !important; */\n}\n\n\n/* Cart area */\n.pos-cart {\n  background: #fafafa;\n  overflow-y: auto;\n  width: 100%;\n  height: 100%; /* ensure full height */\n  display: flex;\n  flex-direction: column;\n  position: sticky; /* make cart sticky */\n  top: 0;\n} \n\n.cart-item-count {\n  color: #111111 !important;\n  cursor: default !important;\n}\n\n/* Content areas for proper scrolling */\n.pos-products-content {\n  flex: 1;\n  overflow-y: auto;\n  height: calc(100% - 60px); /* subtract header height */\n  /* Custom scrollbar styling */\n  scrollbar-width: thin;\n  scrollbar-color: #d9d9d9 transparent;\n}\n\n.pos-products-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.pos-products-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.pos-products-content::-webkit-scrollbar-thumb {\n  background-color: #d9d9d9;\n  border-radius: 3px;\n}\n\n.pos-products-content::-webkit-scrollbar-thumb:hover {\n  background-color: #bfbfbf;\n}\n\n.pos-cart-content {\n  flex: 1;\n  overflow-y: auto;\n  height: calc(100% - 60px); /* subtract header height */\n  /* Custom scrollbar styling */\n  scrollbar-width: thin;\n  scrollbar-color: #d9d9d9 transparent;\n}\n\n.pos-cart-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.pos-cart-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.pos-cart-content::-webkit-scrollbar-thumb {\n  background-color: #d9d9d9;\n  border-radius: 3px;\n}\n\n.pos-cart-content::-webkit-scrollbar-thumb:hover {\n  background-color: #bfbfbf;\n}\n\n/* Cart Items Styling */\n.cart-listing {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.cart-items-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n}\n\n.cart-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cart-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  background: #fff;\n  transition: all 0.2s ease;\n}\n\n.cart-item:hover {\n  border-color: #d9d9d9;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.cart-item .attribute-tag {\n  background-color: #f0f0f0;\n  color: #666;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  width: fit-content;\n}\n\n.cart-item-image {\n  flex-shrink: 0;\n}\n\n.cart-item-placeholder {\n  border: 1px dashed #d9d9d9;\n}\n\n.cart-item-info {\n  min-width: 0; /* Allow text to wrap */\n}\n\n.cart-item-info h4 {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.cart-item-info p {\n  margin: 2px 0;\n  font-size: 12px;\n  color: #666;\n}\n\n/* Cart Item Content */\n.cart-item-content {\n  flex: 1;\n}\n\n/* Cart Item Image */\n.cart-item-img {\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n/* Cart Item Text Elements */\n.cart-item-name {\n  font-size: 13px;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.cart-item-qty {\n  font-size: 12px;\n  display: block;\n  margin-bottom: 2px;\n}\n\n.cart-item-price {\n  font-size: 12px;\n  display: block;\n  margin-bottom: 2px;\n}\n\n.cart-item-subtotal {\n  font-size: 13px;\n  color: #1890ff;\n}\n\n/* Cart Item Remove Button */\n.cart-item-remove-btn {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: centr;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n/* Cart Item Quantity Controls */\n.cart-item-quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  /* margin: 8px 0; */\n}\n\n.cart-item-qty-btn {\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  background: #fff;\n  transition: all 0.2s ease;\n}\n\n.cart-item-qty-btn:hover:not(:disabled) {\n  border-color: #1890ff;\n  color: #1890ff;\n}\n\n.cart-item-qty-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cart-item-qty-input {\n  width: 50px;\n  text-align: center;\n}\n\n.cart-item-qty-input .ant-input-number-input {\n  text-align: center;\n  padding: 0 8px;\n}\n\n/* Cart Item Layout Improvements */\n.cart-item-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.cart-item-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cart-item-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111111;\n  line-height: 1.4;\n  margin: 0;\n}\n\n.cart-item-price-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.cart-item-price {\n  font-size: 12px;\n  color: #666;\n  margin: 0;\n}\n\n.cart-item-subtotal {\n  font-size: 13px;\n  color: #1890ff;\n  font-weight: 600;\n  margin: 0;\n}\n\n.cart-item-right-controls {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: space-between;\n  height: 100%;\n  min-height: 60px;\n  gap: 8px;\n}\n\n.cart-item-quantity-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: auto;\n}\n\n.cart-item-quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background-color: #f5f5f5;\n  border-radius: 6px;\n  padding: 4px;\n  border: 1px solid #e8e8e8;\n}\n\n.cart-item-qty-btn {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.cart-item-qty-btn:hover:not(:disabled) {\n  background-color: #e6f7ff;\n  color: #1890ff;\n}\n\n.cart-item-qty-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cart-item-qty-input {\n  width: 50px;\n  text-align: center;\n  border: none;\n  background: transparent;\n  font-weight: 600;\n}\n\n.cart-item-qty-input .ant-input-number-input {\n  text-align: center;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 0 4px;\n}\n\n/* Cart Item Loading State */\n.cart-item .ant-spin-container {\n  opacity: 1;\n}\n\n.cart-item .ant-spin {\n  position: relative;\n}\n\n.cart-item .ant-spin-spinning .ant-spin-container {\n  opacity: 0.6;\n}\n\n.cart-item .ant-spin-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n}\n\n/* Discounts Component Styling */\n.discounts-card {\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e8e8e8;\n  margin-top: 12px;\n}\n\n.discounts-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.discounts-title {\n  margin: 0 !important;\n  color: #111111;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.discounts-count {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.discounts-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  text-align: center;\n}\n\n.discounts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.discount-item {\n  padding: 0 !important;\n}\n\n.discount-card {\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n  padding: 16px;\n  background: #fafafa;\n  transition: all 0.2s ease;\n}\n\n.discount-card:hover {\n  border-color: #1890ff;\n  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);\n  background: #fff;\n}\n\n.discount-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.discount-code-section {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.discount-code {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111111;\n}\n\n.discount-type-tag {\n  font-weight: 600;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.discount-details {\n  margin-bottom: 16px;\n}\n\n.discount-info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.discount-info-row:last-child {\n  margin-bottom: 0;\n}\n\n.discount-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #666;\n  min-width: 80px;\n}\n\n.discount-value {\n  font-size: 12px;\n  font-weight: 500;\n  color: #111111;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.discount-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.apply-discount-btn {\n  font-weight: 600;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.apply-discount-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);\n}\n\n/* Recent Orders Modal Styling */\n.recent-orders-modal .ant-modal-header {\n  border-bottom: 1px solid #e8e8e8;\n  padding: 0px 0px 16px 0px;\n}\n\n.recent-orders-modal .modal-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.recent-orders-controls {\n  padding: 16px 16px;\n  /* border-bottom: 1px solid #f0f0f0; */\n  background: #fafafa;\n  margin-bottom: 8px;\n}\n\n.search-control {\n  width: 100%;\n}\n\n.search-input {\n  border-radius: 8px;\n  border: 1px solid #d9d9d9;\n  transition: all 0.2s ease;\n}\n\n.search-input:hover {\n  border-color: #1890ff;\n}\n\n.search-input:focus {\n  border-color: #1890ff;\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);\n}\n\n.filter-control {\n  width: 100%;\n}\n\n.date-filter-select {\n  width: 100%;\n  border-radius: 8px;\n}\n\n.date-filter-select .ant-select-selector {\n  border-radius: 8px !important;\n  border: 1px solid #d9d9d9 !important;\n  transition: all 0.2s ease !important;\n}\n\n.date-filter-select:hover .ant-select-selector {\n  border-color: #1890ff !important;\n}\n\n.date-filter-select.ant-select-focused .ant-select-selector {\n  border-color: #1890ff !important;\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important;\n}\n\n.filter-info {\n  text-align: right;\n  padding: 8px 0;\n}\n\n.filter-info .ant-typography {\n  font-size: 13px;\n}\n\n.recent-orders-content {\n  padding: 0;\n}\n\n.empty-orders {\n  text-align: center;\n  padding: 40px 20px;\n  color: #999;\n}\n\n.recent-orders-table {\n  margin-top: 0;\n}\n\n.recent-orders-table .ant-table-thead > tr > th {\n  background: #fafafa;\n  border-bottom: 1px solid #e8e8e8;\n  font-weight: 600;\n  color: #111111;\n}\n\n.recent-orders-table .ant-table-tbody > tr > td {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 12px 16px;\n}\n\n.recent-orders-table .ant-table-tbody > tr:hover > td {\n  background: #f5f5f5;\n}\n\n.table-header-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.header-icon {\n  color: #1890ff;\n}\n\n.order-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.order-number {\n  font-size: 14px;\n  color: #111111;\n}\n\n.order-id {\n  font-size: 12px;\n  color: #666;\n}\n\n.customer-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.customer-name {\n  font-size: 14px;\n  color: #111111;\n}\n\n.customer-email {\n  font-size: 12px;\n  color: #666;\n}\n\n.date-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.order-date {\n  font-size: 13px;\n  color: #111111;\n}\n\n.total-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.order-total {\n  font-size: 14px;\n  color: #111111;\n}\n\n.status-tag {\n  font-weight: 500;\n  border-radius: 4px;\n}\n\n.load-order-btn {\n  font-weight: 500;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.load-order-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);\n}\n\n.view-invoice-btn {\n  font-weight: 500;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.view-invoice-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);\n}\n\n/* Payment Modal Styling */\n.payment-modal .ant-modal-header {\n  border-bottom: 1px solid #e8e8e8;\n  padding: 0px 0px 16px 0px;\n}\n\n.payment-modal-content {\n  padding: 0;\n}\n\n.payment-summary {\n  background: #f8f9fa;\n  padding: 16px;\n  border-radius: 8px;\n  /* margin-bottom: 16px; */\n}\n\n.summary-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.summary-label {\n  font-size: 16px;\n  font-weight: 500;\n  color: #111111;\n}\n\n.summary-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1890ff;\n}\n\n/* .internal-payment-content {\n  padding-bottom: 16px;\n} */\n\n.cash-payment-section {\n  margin-bottom: 20px;\n}\n\n.cash-input-group {\n  background: #f8f9fa;\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  border: 1px solid #e8e8e8;\n}\n\n.cash-input-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.cash-input-item:last-child {\n  margin-bottom: 0;\n}\n\n.cash-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111111;\n}\n\n.cash-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1890ff;\n}\n\n.cash-received-input {\n  width: 120px;\n  text-align: right;\n}\n\n.cash-received-input .ant-input {\n  text-align: right;\n  font-weight: 600;\n}\n\n.change-item {\n  padding-top: 8px;\n  border-top: 1px solid #e8e8e8;\n  margin-top: 8px;\n}\n\n.change-value.positive {\n  color: #52c41a;\n  font-weight: 700;\n}\n\n.change-value.negative {\n  color: #ff4d4f;\n  font-weight: 700;\n}\n\n.online-payment-section {\n  margin-top: 20px;\n}\n\n.quick-amounts-section {\n  margin-bottom: 16px;\n}\n\n.quick-amounts-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111111;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.quick-amounts-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.quick-amount-wrapper {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.quick-amount-btn {\n  height: 40px;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 6px;\n  background: #fff;\n  border: 1px solid #d9d9d9;\n  color: #111111;\n  transition: all 0.2s ease;\n}\n\n.quick-amount-btn:hover:not(:disabled) {\n  background: #f0f0f0;\n  border-color: #40a9ff;\n  color: #1890ff;\n  transform: translateY(-1px);\n}\n\n.quick-amount-btn:active:not(:disabled) {\n  transform: translateY(0);\n  background: #e6f7ff;\n}\n\n.clear-cash-btn {\n  width: 100%;\n  height: 36px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  background: #ff4d4f;\n  border-color: #ff4d4f;\n  color: #fff;\n  transition: all 0.2s ease;\n}\n\n.clear-cash-btn:hover:not(:disabled) {\n  background: #ff7875;\n  border-color: #ff7875;\n  transform: translateY(-1px);\n}\n\n.clear-cash-btn:active:not(:disabled) {\n  transform: translateY(0);\n  background: #d9363e;\n}\n\n.amount-count-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  background: #1890ff;\n  color: #fff;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  border: 2px solid #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n.payment-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.payment-option-btn {\n  height: 48px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.quick-cash-btn {\n  background: #52c41a;\n  border-color: #52c41a;\n}\n\n.quick-cash-btn:hover:not(:disabled) {\n  background: #73d13d;\n  border-color: #73d13d;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.3);\n}\n\n.online-payment-btn {\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n  color: #999;\n  cursor: not-allowed;\n}\n\n.qr-code-section {\n  text-align: center;\n  padding: 20px;\n  background: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #e8e8e8;\n}\n\n.external-payment-content {\n  padding: 0px 0;\n}\n\n.external-payment-btn {\n  height: 48px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  /* margin-top: 16px; */\n  transition: all 0.2s ease;\n}\n\n.external-payment-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);\n}\n\n/* Payment Modal Tabs */\n.payment-modal .ant-tabs-tab {\n  padding: 12px 16px;\n  font-weight: 500;\n}\n\n.payment-modal .ant-tabs-tab-active {\n  color: #1890ff;\n}\n\n.payment-modal .ant-tabs-ink-bar {\n  background: #1890ff;\n}\n\n.payment-modal .ant-tabs-content-holder {\n  padding: 0;\n}\n\n/* Responsive adjustments for Payment Modal */\n@media (max-width: 768px) {\n  .payment-modal .ant-modal {\n    width: 95% !important;\n    max-width: 95% !important;\n  }\n  \n  .payment-option-btn {\n    height: 44px;\n    font-size: 14px;\n  }\n  \n  .external-payment-btn {\n    height: 44px;\n    font-size: 14px;\n  }\n  \n  .qr-code-section {\n    padding: 16px;\n  }\n  \n  .summary-value {\n    font-size: 18px;\n  }\n  \n  .cash-input-group {\n    padding: 12px;\n  }\n  \n  .cash-received-input {\n    width: 100px;\n  }\n  \n  .cash-label {\n    font-size: 13px;\n  }\n  \n  .cash-value {\n    font-size: 15px;\n  }\n  \n  .quick-amounts-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 6px;\n  }\n  \n  .quick-amount-btn {\n    height: 36px;\n    width: 100%;\n    font-size: 13px;\n  }\n  \n  .clear-cash-btn {\n    height: 32px;\n    font-size: 13px;\n  }\n  \n  .amount-count-badge {\n    width: 18px;\n    height: 18px;\n    font-size: 10px;\n    top: -5px;\n    right: -5px;\n  }\n}\n\n/* Responsive adjustments for Recent Orders Modal */\n@media (max-width: 768px) {\n  .recent-orders-modal .ant-modal {\n    width: 95% !important;\n    max-width: 95% !important;\n  }\n  \n  .recent-orders-controls {\n    padding: 12px 16px;\n  }\n  \n  .filter-info {\n    text-align: center;\n    margin-top: 8px;\n  }\n  \n  .recent-orders-table .ant-table-thead > tr > th,\n  .recent-orders-table .ant-table-tbody > tr > td {\n    padding: 8px 12px;\n  }\n  \n  .order-number,\n  .customer-name,\n  .order-total {\n    font-size: 13px;\n  }\n  \n  .order-id,\n  .customer-email {\n    font-size: 11px;\n  }\n  \n  .view-invoice-btn {\n    font-size: 12px;\n    padding: 4px 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .recent-orders-controls .ant-row {\n    flex-direction: column;\n  }\n  \n  .recent-orders-controls .ant-col {\n    margin-bottom: 12px;\n  }\n  \n  .filter-info {\n    text-align: left;\n    margin-top: 0;\n  }\n}\n\n.empty-cart {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* height: 200px; */\n  color: #999;\n  font-size: 14px;\n  margin-top:28px;\n}\n\n/* Cart Order Options Styling */\n.cart-order-options {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  background: #fff;\n}\n\n.cart-order-options .ant-segmented {\n  background: #f5f5f5;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.cart-order-options .ant-segmented-item {\n  font-size: 11px;\n  font-weight: 500;\n  padding: 6px 8px;\n  border-radius: 4px !important;\n  transition: all 0.2s ease;\n}\n\n/* .cart-order-options .ant-segmented-item-selected {\n  background: #111111;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n} */\n\n.cart-order-options .ant-segmented-item:hover:not(.ant-segmented-item-selected) {\n  background: #e6e6e6;\n  color: #333;\n}\n\n/* POS Customer Styling */\n.pos-customer-section {\n  padding: 12px 0px;\n  padding-bottom: 0px;\n  background: #fff;\n}\n\n.pos-customer-section .ant-form-item-label > label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #666;\n}\n\n.pos-customer-section .ant-input,\n.pos-customer-section .ant-select-selector {\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n}\n\n.pos-customer-section .ant-input:focus,\n.pos-customer-section .ant-select-focused .ant-select-selector {\n  border-color: #111111;\n  box-shadow: 0 0 0 2px rgba(17, 17, 17, 0.1);\n}\n\n.customer-details-section {\n  /* margin-top: 8px; */\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.customer-details-section .ant-form-item {\n  margin-bottom: 12px;\n}\n\n.customer-details-section .ant-input-prefix {\n  color: #999;\n}\n\n.pos-customer-section .ant-select-item-option-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Cart Order Actions Styling */\n.cart-order-actions {\n  position: sticky;\n  bottom: 0;\n  background: #fff;\n  border-top: 1px solid #f0f0f0;\n  padding: 10px;\n  padding-bottom: 0px;\n  margin-top: auto;\n}\n\n.cart-details-section {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  padding: 8px;\n  margin-bottom: 6px;\n}\n\n.cart-detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.cart-detail-item:last-child {\n  margin-bottom: 0;\n}\n\n.cart-detail-label {\n  font-size: 11px;\n  color: #666;\n  font-weight: 500;\n}\n\n.cart-detail-value {\n  font-size: 11px;\n  color: #333;\n  font-weight: 600;\n}\n\n/* .cart-total-bar {\n  background: #111111;\n  padding: 8px 12px;\n  border-radius: 6px;\n  margin-bottom: 8px;\n} */\n\n.cart-total-label {\n  color: #111111;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.cart-total-amount {\n  color: #111111;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.cart-action-buttons {\n  margin-top: 6px;\n}\n\n.cart-buttons-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: auto auto auto;\n  gap: 6px;\n  max-width: 100%;\n}\n\n.cart-buttons-grid .cart-action-btn:nth-child(1) {\n  grid-column: 1 / 1;\n  grid-row: 1 / 1;\n}\n\n.cart-buttons-grid .cart-action-btn:nth-child(2) {\n  grid-column: 1 / 2.5;\n  grid-row: 1 / 1;\n}\n\n.cart-buttons-grid .cart-action-btn:nth-child(3) {\n  grid-column: 1 / 3.5;\n  grid-row: 1 / 1;\n}\n\n/* .cart-buttons-grid .cart-action-btn:nth-child(4) {\n  grid-column: 2 / 3;\n  grid-row: 2 / 3;\n} */\n\n.cart-action-btn {\n  height: 32px;\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 11px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  border: none;\n  transition: all 0.2s ease;\n  padding: 0 6px;\n  min-width: 0;\n}\n\n.cart-action-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.cart-action-btn:active {\n  transform: translateY(0);\n}\n\n.cart-action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.cart-action-btn:disabled:hover {\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.cart-action-btn span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.suspend-btn {\n  background: #fff3cd;\n  color: #856404;\n  border: 1px solid  #ebc044;\n}\n\n.suspend-btn:hover {\n  background: #ffeaa7;\n  color: #856404;\n}\n\n.cash-payment-btn {\n  background: #87ceeb;\n  color: #1e3a8a;\n  border: 1px solid #4682b4;\n}\n\n.cash-payment-btn:hover {\n  background: #4682b4;\n  color: white;\n}\n\n.payment-btn {\n  background: #90ee90;\n  color: #006400;\n  border: 1px solid #32cd32;\n}\n\n.payment-btn:hover {\n  background: #32cd32;\n  color: white;\n}\n\n.cancel-btn {\n  background: #ffb3ba;\n  color: #8b0000;\n  border: 1px solid #ff6b6b;\n}\n\n.cancel-btn:hover {\n  background: #ff6b6b;\n  color: white;\n}\n\n\n/* Suspended Cart Modal */\n.suspended-cart-card {\n  background: #fffbe6;\n  border: 1px solid #ffe58f;\n  border-radius: 8px;\n  padding: 20px;\n  color: #333;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  transition: all 0.3s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  cursor: pointer;\n}\n\n.suspended-cart-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  border-color: #ffd666;\n  background: #fff9d6;\n}\n\n.suspended-cart-card:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.suspended-cart-header {\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.suspended-cart-ref {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: #333;\n}\n\n.suspended-cart-customer {\n  font-size: 12px;\n  font-weight: 400;\n  color: #666;\n}\n\n.suspended-cart-details {\n  flex: 1;\n}\n\n.suspended-cart-detail-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #333;\n}\n\n.suspended-cart-detail-item:last-child {\n  margin-bottom: 0;\n}\n\n.suspended-cart-detail-item svg {\n  color: #faad14;\n  flex-shrink: 0;\n}\n\n.suspended-cart-detail-item span {\n  flex: 1;\n  color: #333;\n}\n\n.suspended-cart-footer {\n  margin-top: auto;\n}\n\n.suspended-by-info {\n  text-align: center;\n  padding: 4px 0;\n}\n\n.suspended-by-info .ant-typography {\n  margin: 0;\n}\n\n/* Product Quick View Modal Styles */\n.product-quick-view-modal .ant-modal-content {\n  padding: 0;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.product-quick-view-modal .modal-header {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 2;\n}\n\n.product-quick-view-modal .modal-body {\n  display: grid;\n  gap: 16px;\n  padding: 16px;\n  grid-template-columns: 320px 1fr;\n}\n\n.product-quick-view-modal .product-image-section {\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 280px;\n  max-height: 280px;\n}\n\n.product-quick-view-modal .image-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.product-quick-view-modal .product-details-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: space-between;\n}\n\n.product-quick-view-modal .product-meta {\n  margin-top: 12px;\n}\n\n.product-quick-view-modal .product-tags {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.composite-products-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* .product-quick-view-modal .product-tabs .ant-tabs-tab {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 999px;\n  background: #fff;\n  margin-right: 8px;\n} */\n\n/* .product-quick-view-modal .product-tabs .ant-tabs-tab-active {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n} */\n\n.product-quick-view-modal .pricing-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.product-quick-view-modal .price-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.product-quick-view-modal .price-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.product-quick-view-modal .add-to-cart-section {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 12px;\n  margin-top: 0px;\n}\n\n.product-quick-view-modal .quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.product-quick-view-modal .quantity-controls .ant-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #f3f4f6;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.product-quick-view-modal .quantity-controls .ant-btn:hover {\n  background: #111111;\n  color: #ffffff;\n}\n\n\n.product-quick-view-modal .quantity-controls .ant-input-number {\n  width: 80px;\n}\n\n.product-quick-view-modal .quantity-controls .ant-input-number-input {\n  text-align: center;\n  padding: 4px 12px;\n  border-radius: 10px;\n  font-size: 18px;\n}\n\n.product-quick-view-modal .discounts-section,\n.product-quick-view-modal .related-section {\n  padding: 20px;\n  text-align: center;\n  color: #64748b;\n}\n\n/* Gift Card Section Styles */\n.product-quick-view-modal .gift-card-section {\n  padding: 0px 0;\n}\n\n.product-quick-view-modal .gift-card-info {\n  margin-bottom: 20px;\n  padding: 12px;\n  background: #f6f8fa;\n  border-radius: 8px;\n  border-left: 4px solid #52c41a;\n}\n\n.product-quick-view-modal .gift-card-form {\n  display: flex;\n  flex-direction: column;\n  /* gap: 16px; */\n}\n\n.product-quick-view-modal .gift-card-form .form-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.product-quick-view-modal .gift-card-form .ant-input-number {\n  width: 100%;\n}\n\n.product-quick-view-modal .gift-card-form .ant-input {\n  width: 100%;\n}\n\n.product-quick-view-modal .gift-card-form .ant-select {\n  width: 100%;\n}\n\n  .product-quick-view-modal .gift-card-form .ant-input-number-prefix {\n    /* color: #52c41a; */\n    font-weight: bold;\n  }\n\n  /* Variable Products Section Styles */\n  .product-quick-view-modal .variable-products-section {\n    padding: 0px 0px 0px 0;\n  }\n\n  .product-quick-view-modal .variable-products-header {\n    margin-bottom: 8px;\n  }\n\n  .product-quick-view-modal .variable-products-table {\n    border: 1px solid #f0f0f0;\n    border-radius: 8px;\n    overflow: hidden;\n  }\n\n  .product-quick-view-modal .variable-table .ant-table-thead > tr > th {\n    background-color: #fafafa;\n    font-weight: 600;\n    border-bottom: 1px solid #f0f0f0;\n  }\n\n  .product-quick-view-modal .add-all-variables-section {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid #e8e8e8;\n  }\n/* \n  .product-quick-view-modal .add-all-variables-btn {\n    height: 48px; \n    font-size: 16px; \n    border-radius: 8px; \n   background: #1890ff; \n   border-color: #1890ff;\n    transition: all 0.2s ease;\n  } */\n\n  /* .product-quick-view-modal .add-all-variables-btn:hover:not(:disabled) {\n    background: #40a9ff;\n    border-color: #40a9ff;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);\n  } */\n\n  .product-quick-view-modal .variant-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .product-quick-view-modal .variant-name {\n    font-weight: 600;\n    color: #111111;\n    font-size: 14px;\n  }\n\n  .product-quick-view-modal .variant-attributes {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n\n  .product-quick-view-modal .attribute-tag {\n    background-color: #f0f0f0;\n    color: #666;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .product-quick-view-modal .variant-price {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .product-quick-view-modal .sale-price {\n    color: #52c41a;\n    font-weight: 600;\n    font-size: 14px;\n  }\n\n  .product-quick-view-modal .original-price {\n    color: #999;\n    text-decoration: line-through;\n    font-size: 12px;\n  }\n\n  .product-quick-view-modal .regular-price {\n    color: #111111;\n    font-weight: 600;\n    font-size: 14px;\n  }\n\n  .product-quick-view-modal .variant-stock {\n    display: flex;\n    align-items: center;\n  }\n\n  .product-quick-view-modal .stock-status {\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .product-quick-view-modal .stock-status.in-stock {\n    background-color: #f6ffed;\n    color: #52c41a;\n    border: 1px solid #b7eb8f;\n  }\n\n  .product-quick-view-modal .stock-status.out-of-stock {\n    background-color: #fff2f0;\n    color: #ff4d4f;\n    border: 1px solid #ffccc7;\n  }\n\n  .product-quick-view-modal .stock-status.unlimited {\n    background-color: #f0f0f0;\n    color: #666;\n    border: 1px solid #d9d9d9;\n  }\n\n  .product-quick-view-modal .variant-quantity-controls {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  .product-quick-view-modal .variant-quantity-controls .ant-btn {\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .product-quick-view-modal .variant-quantity-controls .ant-input-number {\n    width: 70px;\n  }\n\n  .product-quick-view-modal .variant-quantity-controls .ant-input-number-input {\n    text-align: center;\n    padding: 4px 8px;\n  }\n\n  /* Bill Styles */\n  .pos-bill-wrapper {\n    min-height: 100vh;\n    background-color: #f5f5f5;\n    padding: 20px;\n  }\n\n  .bill-actions {\n    margin-bottom: 20px;\n    padding: 16px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .bill-content {\n    /* background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */\n    overflow: hidden;\n  }\n\n  .bill-container {\n    padding: 30px;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  }\n\n  /* Bill Header */\n  .bill-header {\n    margin-bottom: 30px;\n    padding-bottom: 20px;\n    border-bottom: 2px solid #f0f0f0;\n  }\n\n  .company-info {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n  }\n\n  .bill-logo {\n    height: 40px;\n    width: auto;\n    /* border-radius: 8px; */\n    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */\n  }\n\n  .company-name {\n    margin: 0 !important;\n    color: #111111;\n    font-size: 28px;\n    font-weight: 700;\n  }\n\n  .company-tagline {\n    color: #666;\n    font-size: 16px;\n    margin-top: 4px;\n  }\n\n  .bill-info {\n    text-align: right;\n  }\n\n  .bill-title-text {\n    margin: 0 !important;\n    color: #111111;\n    font-size: 28px !important;\n    font-weight: 600;\n    /* letter-spacing: 1px; */\n  }\n\n  .bill-details {\n    /* margin-top: 20px; */\n    background-color: #f8f9fa;\n    padding: 16px;\n    border-radius: 8px;\n    border: 1px solid #e9ecef;\n    max-width: 280px;\n    margin-left: auto;\n  }\n\n  .bill-detail-row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    font-size: 16px;\n  }\n\n  .bill-detail-row:last-child {\n    margin-bottom: 0;\n  }\n\n  .bill-container .status-tag {\n    font-weight: 600;\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n  }\n\n  /* Bill Customer Details */\n  .bill-customer-section {\n    margin: 0;\n  }\n\n  .customer-details-card {\n    height: 100%;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    border: 1px solid #e8e8e8;\n  }\n\n  .customer-details-card .ant-card-body {\n    padding: 20px;\n  }\n\n  .customer-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 16px;\n  }\n\n  .customer-avatar {\n    background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);\n    border: 3px solid #e6f7ff;\n  }\n\n  .customer-avatar.walk-in {\n    background: linear-gradient(135deg, #fa8c16 0%, #ffa940 100%);\n    border-color: #fff7e6;\n  }\n\n  .customer-avatar.no-customer {\n    background: linear-gradient(135deg, #8c8c8c 0%, #bfbfbf 100%);\n    border-color: #f5f5f5;\n  }\n\n  .customer-title-section {\n    flex: 1;\n  }\n\n  .customer-title {\n    margin: 0 !important;\n    color: #111111;\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  .customer-type-tag {\n    margin-top: 4px;\n    font-size: 12px;\n    padding: 2px 8px;\n    border-radius: 12px;\n  }\n\n  .customer-divider {\n    margin: 16px 0;\n    border-color: #f0f0f0;\n  }\n\n  .customer-info-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .info-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px;\n    background-color: #fafafa;\n    border-radius: 8px;\n    border: 1px solid #f0f0f0;\n  }\n\n  .info-item.full-width {\n    grid-column: 1 / -1;\n  }\n\n  .info-icon {\n    color: #1890ff;\n    font-size: 16px;\n    margin-top: 2px;\n    flex-shrink: 0;\n  }\n\n  .info-content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .info-label {\n    display: block;\n    font-size: 12px;\n    font-weight: 500;\n    color: #8c8c8c;\n    margin-bottom: 4px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  .info-value {\n    display: block;\n    font-size: 14px;\n    color: #111111;\n    word-break: break-word;\n  }\n\n  /* Bill Items Table */\n  .bill-items-section {\n    margin: 0;\n  }\n\n  .modern-items-card {\n    height: 100%;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    border: 1px solid #e8e8e8;\n  }\n\n  .modern-items-card .ant-card-body {\n    padding: 0;\n  }\n\n  .items-header-modern {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px 16px;\n    /* background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%); */\n    border-radius: 12px 12px 0 0;\n  }\n\n  .header-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .items-title {\n    margin: 0 !important;\n    color: #111111;\n    font-size: 18px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .title-icon {\n    color: #1890ff;\n    font-size: 20px;\n  }\n\n  .items-count-tag {\n    font-size: 12px;\n    padding: 4px 12px;\n    border-radius: 16px;\n    font-weight: 500;\n  }\n\n  .header-right {\n    text-align: right;\n  }\n\n  .subtotal-preview {\n    font-size: 14px;\n    color: #666;\n  }\n\n  .items-divider {\n    margin: 0;\n    border-color: #f0f0f0;\n  }\n\n  .modern-items-table {\n    border: none;\n  }\n\n  .modern-items-table .ant-table {\n    border-radius: 0px !important;\n    border: none !important;\n  }\n\n  .modern-items-table .ant-table-thead > tr > th {\n    /* background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%); */\n    font-weight: 600;\n    color: #111111;\n    /* border-bottom: 2px solid #e8e8e8; */\n    padding: 16px 20px;\n    font-size: 13px;\n  }\n\n  .table-header-cell {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .header-icon {\n    color: #1890ff;\n    font-size: 14px;\n  }\n\n  .modern-items-table .ant-table-tbody > tr > td {\n    padding: 16px 20px;\n    border-bottom: 1px solid #f0f0f0;\n    vertical-align: middle;\n    height: 80px;\n  }\n\n  .modern-items-table .ant-table-tbody > tr {\n    height: 80px;\n  }\n\n  .modern-items-table .ant-table-tbody > tr:hover > td {\n    background-color: #f8f9fa;\n  }\n\n  .modern-item-info {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .item-image-container {\n    flex-shrink: 0;\n  }\n\n  .modern-item-image {\n    width: 50px;\n    height: 50px;\n    object-fit: cover;\n    border-radius: 6px;\n    border: 1px solid #e8e8e8;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n\n  .modern-item-image .ant-image {\n    width: 50px;\n    height: 50px;\n  }\n\n  .modern-item-image .ant-image-img {\n    width: 50px !important;\n    height: 50px !important;\n    object-fit: cover;\n  }\n\n  .modern-item-image .ant-image-mask {\n    width: 50px !important;\n    height: 50px !important;\n  }\n\n  .image-fallback {\n    width: 50px;\n    height: 50px;\n    background-color: #f5f5f5;\n    border: 1px solid #e8e8e8;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .fallback-icon {\n    color: #bfbfbf;\n    font-size: 20px;\n  }\n\n  .item-details-modern {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .item-name-modern {\n    margin-bottom: 8px;\n  }\n\n  .product-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: #111111;\n    line-height: 1.4;\n  }\n\n  .item-meta {\n    margin-top: 8px;\n  }\n\n  .sku-tag,\n  .variant-tag {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-weight: 500;\n  }\n\n  .price-cell,\n  .quantity-cell,\n  .subtotal-cell {\n    text-align: right;\n  }\n\n\n  .subtotal-amount {\n    font-size: 15px;\n    font-weight: 600;\n    color: #111111;\n  }\n\n  .quantity-tag {\n    font-size: 12px;\n    padding: 4px 12px;\n    border-radius: 16px;\n    font-weight: 600;\n  }\n\n  /* Bill Summary */\n  .bill-summary-section {\n    margin: 24px 0;\n  }\n\n  .bill-summary-section .ant-row {\n    margin-bottom: 16px;\n  }\n\n  .order-summary-card,\n  .tip-card {\n    background-color: #fafafa;\n    border: 1px solid #f0f0f0;\n    height: 100%;\n    border-radius: 12px;\n  }\n\n  .order-summary-card .ant-card-head,\n  .tip-card .ant-card-head {\n    background-color: #f5f5f5;\n    border-bottom: 1px solid #e8e8e8;\n    padding: 16px 20px;\n    border-radius: 12px 12px 0 0;\n  }\n\n  .order-summary-card .ant-card-head-title,\n  .tip-card .ant-card-head-title {\n    font-weight: 600;\n    color: #111111;\n    font-size: 16px;\n  }\n\n  .order-summary-card .ant-card-body,\n  .tip-card .ant-card-body {\n    padding: 20px;\n  }\n\n  .summary-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n    padding: 8px 0;\n  }\n\n  .summary-item:last-child {\n    margin-bottom: 0;\n  }\n\n  .tip-section {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  /* .tip-type-selector {\n    margin-bottom: 16px;\n  } */\n\n  .quick-tip-options {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .tip-buttons {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n  }\n\n  .tip-option-btn {\n    height: 40px;\n    font-weight: 500;\n    border-radius: 8px;\n  }\n\n  .custom-tip-input {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .tip-summary {\n    background-color: #f8f9fa;\n    padding: 16px;\n    border-radius: 8px;\n    border: 1px solid #e8e8e8;\n  }\n\n  .total-payable-card {\n    background: linear-gradient(135deg, #111111 0%, #333333 100%);\n    border: none;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    border-radius: 12px;\n    margin-top: 24px;\n  }\n\n  .total-payable-card .ant-card-body {\n    padding: 20px 24px;\n  }\n\n  .summary-item.total-item {\n    margin: 0;\n    padding: 0;\n    background: none;\n    border: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .summary-item.total-item .ant-typography {\n    color: white !important;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    margin: 0 !important;\n  }\n\n  /* Bill Footer */\n  .bill-footer-section {\n    margin-top: 20px;\n  }\n\n  .payment-info {\n    padding: 16px;\n    text-align: center;\n  }\n\n  .bill-footer-bottom {\n    margin-top: 20px;\n    padding-top: 20px;\n  }\n\n  /* Print Styles */\n  @media print {\n    .no-print {\n      display: none !important;\n    }\n\n    .pos-bill-wrapper {\n      background: white;\n      padding: 0;\n    }\n\n    .bill-content {\n      box-shadow: none;\n      border-radius: 0;\n    }\n\n    .bill-container {\n      padding: 20px;\n    }\n\n    .bill-actions {\n      display: none;\n    }\n\n    .bill-header {\n      page-break-inside: avoid;\n    }\n\n    .bill-items-table {\n      page-break-inside: avoid;\n    }\n\n    .bill-summary-section {\n      page-break-inside: avoid;\n    }\n  }\n\n  /* Responsive */\n  @media (max-width: 768px) {\n    .bill-container {\n      padding: 20px;\n    }\n\n    .company-info {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 12px;\n    }\n\n    .bill-info {\n      text-align: left;\n      /* margin-top: 20px; */\n    }\n\n    .bill-title-text {\n      font-size: 28px;\n    }\n\n    .bill-details {\n      max-width: 100%;\n      margin-left: 0;\n    }\n\n    .bill-item-info {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n    }\n\n    .item-image {\n      align-self: center;\n    }\n\n    .tip-buttons {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    .order-summary-card .ant-card-body,\n    .tip-card .ant-card-body {\n      padding: 16px;\n    }\n\n    .bill-summary-section {\n      margin: 20px 0;\n    }\n\n    .summary-item {\n      margin-bottom: 10px;\n      padding: 6px 0;\n    }\n\n    .tip-section {\n      gap: 16px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .bill-container {\n      padding: 16px;\n    }\n\n    .bill-title-text {\n      font-size: 24px;\n    }\n\n    .company-name {\n      font-size: 24px;\n    }\n\n    .tip-buttons {\n      grid-template-columns: 1fr;\n    }\n  }\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .suspended-cart-card {\n    padding: 16px;\n  }\n  \n  .suspended-cart-ref {\n    font-size: 16px;\n  }\n  \n  .suspended-cart-customer {\n    font-size: 13px;\n  }\n  \n  .suspended-cart-detail-item {\n    font-size: 12px;\n  }\n  \n  .product-quick-view-modal .modal-body {\n    grid-template-columns: 1fr;\n  }\n  \n  .product-quick-view-modal .product-image-section {\n    min-height: 200px;\n  }\n}\n/* Loyalty Points Section */\n.loyalty-points-section {\n  margin: 12px 0;\n  padding: 10px;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border: 1px solid #bae6fd;\n  border-radius: 8px;\n}\n\n.loyalty-points-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.loyalty-points-info {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: flex-start;\n  flex: 1;\n}\n\n.loyalty-points-main {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.loyalty-points-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.loyalty-detail-row {\n  display: flex;\n  /* justify-content: space-between; */\n  align-items: center;\n  gap: 8px;\n}\n\n.loyalty-detail-label {\n  font-size: 10px;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.loyalty-detail-value {\n  font-size: 10px;\n  color: #0c4a6e;\n  font-weight: 600;\n}\n\n.loyalty-points-label {\n  font-size: 12px;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.loyalty-points-value {\n  font-size: 12px;\n  color: #0c4a6e;\n  font-weight: 600;\n}\n\n.use-points-btn {\n  background: #0369a1;\n  border-color: #0369a1;\n  color: #fff;\n  font-weight: 500;\n  border-radius: 6px;\n  height: 32px;\n  padding: 0 16px;\n  transition: all 0.2s ease;\n}\n\n.use-points-btn:hover:not(:disabled) {\n  background: #0284c7 !important;\n  border-color: #0284c7 !important;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(3, 105, 161, 0.3);\n}\n\n.use-points-btn:disabled {\n  background: #94a3b8;\n  border-color: #94a3b8;\n  color: #fff;\n}\n\n/* Redeemed Points Section */\n.redeemed-points-section {\n  margin: 12px 0;\n  padding: 10px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);\n  border: 1px solid #bbf7d0;\n  border-radius: 8px;\n}\n\n.redeemed-points-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.redeemed-points-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: flex-start;\n}\n\n.redeemed-points-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.redeemed-points-label {\n  font-size: 12px;\n  color: #166534;\n  font-weight: 500;\n}\n\n.redeemed-points-value {\n  font-size: 12px;\n  color: #14532d;\n  font-weight: 600;\n}\n\n.redeemed-discount-value {\n  font-size: 12px;\n  color: #16a34a;\n  font-weight: 600;\n}\n\n.cancel-points-btn {\n  color: #ef4444;\n  background: transparent;\n  border: none;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  min-width: auto;\n  height: auto;\n}\n\n.cancel-points-btn:hover:not(:disabled) {\n  background: #fef2f2 !important;\n  color: #dc2626 !important;\n  transform: scale(1.1);\n}\n\n.cancel-points-btn:disabled {\n  color: #94a3b8;\n  background: transparent;\n}\n\n/* POS end */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
